import {
    dateFormatFuncForExcel,
    meterToKilo, secToDayPercent, secToHourMinute,
    secToMinute
} from "@/components/tacho/common/CommonFunc";
import tachoEntity, {carTypeNames} from "@/entity/TachoEntity";
import {MeterStatusType} from "@/type";
import PayType, {convertPayTypeToTxt} from '@/type/PayType';

const excelType = {
    0: "기본(엑셀)",
    1: "지불상세(엑셀)",
    2: "세계업로드(엑셀)",
    3: "세계업로드(TXT)"
}

// 기본
class baseExcelEntity {
    constructor(carNum, driverId, minDtti, maxDtti, workTime, allTime, workDist, blankDist, fare, payFare, hipassFare, addFare, callFare, payType, payDtti, viewYn, allDist, blankTime) {
        this.carNum = carNum;
        this.driverId = driverId;
        this.minDtti = minDtti;
        this.maxDtti = maxDtti;
        this.workTime = workTime;
        this.allTime = allTime;
        this.workDist = workDist;
        this.blankDist = blankDist;
        this.fare = fare;
        this.payFare = payFare;
        this.hipassFare = hipassFare;
        this.addFare = addFare;
        this.callFare = callFare;
        this.payType = payType;
        this.payDtti = payDtti;
        this.viewYn = viewYn;
        //this.totalDist = workDist + blankDist;
        this.allDist = allDist;
        this.blankTime = blankTime;
    }

    fromMap(no, v) {
        let s = {
            alignment: {horizontal: "center"},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }
        return [
            {v: no, t: "n", s: s},
            {v: v.carNum, t: "s", s: s},
            {v: v.driverId, t: "s", z: '@', s: s},
            {
                v: `${dateFormatFuncForExcel(v.minDtti, 'YYYY-MM-DD HH:mm')} ~ ${dateFormatFuncForExcel(v.maxDtti, 'YYYY-MM-DD HH:mm')}`,
                t: "s",
                s: s
            },
            {v: v.payFare, t: "n", z: "#,##0", s: s},
            {v: v.hipassFare, t: "n", z: "#,##0", s: s},
            {v: v.callFare, t: "n", z: "#,##0", s: s},
            {v: v.addFare, t: "n", z: "#,##0", s: s},
            {v: v.fare, t: "n", z: "#,##0", s: s},
            {v: meterToKilo(v.workDist), t: "n", z: '0.0', s: s},
            {v: meterToKilo(v.blankDist), t: "n", z: '0.0', s: s},
            {v: meterToKilo(v.allDist), t: "n", z: '0.0', s: s},
            {v: secToDayPercent(v.workTime), t: "n", z: "[h]:mm:ss", s: s},
            {v: secToDayPercent(v.blankTime), t: "n", z: "[h]:mm:ss", s: s},
            {v: secToDayPercent(v.allTime), t: "n", z: "[h]:mm:ss", s: s}
        ]
    }

    fields() {
        let s = {
            fill: {fgColor: {rgb: "FFFF00"}},
            alignment: {horizontal: "center"},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }
        return [
            {key: "no", label: {v: "순번", t: "s", s: s}},
            {key: "carNum", label: {v: "차량번호", t: "s", s: s}},
            {key: "driverId", label: {v: "사원번호", t: "s", s: s}},
            {key: "period", label: {v: "운행기간", t: "s", s: s}},
            {key: "payFare", label: {v: "미터금액 (원)", t: "s", s: s}},
            {key: "hipassFare", label: {v: "통행요금 (원)", t: "s", s: s}},
            {key: "callFare", label: {v: "호출요금 (원)", t: "s", s: s}},
            {key: "addFare", label: {v: "추가금액 (원)", t: "s", s: s}},
            {key: "fare", label: {v: "합계금액 (원)", t: "s", s: s}},
            {key: "workDist", label: {v: "영업거리(KM)", t: "s", s: s}},
            {key: "blankDist", label: {v: "주행거리(KM)", t: "s", s: s}},
            {key: "allDist", label: {v: "총 운행거리(KM)", t: "s", s: s}},
            {key: "workTime", label: {v: "영업시간", t: "s", s: s}},
            {key: "blankTime", label: {v: "주행시간", t: "s", s: s}},
            {key: "allTime", label: {v: "근무시간", t: "s", s: s}},
        ]
    }

    cols() {
        return [
            {width: 10.0},
            {width: 15.0},
            {width: 12.0},
            {width: 35.0},
            {width: 15.0},
            {width: 15.0},
            {width: 15.0},
            {width: 15.0},
            {width: 15.0},
            {width: 15.0},
            {width: 15.0},
            {width: 17.0},
            {width: 10.0},
            {width: 10.0},
            {width: 10.0},
        ]
    }
}

class baseExcelSumEntity {
    constructor() {
        this.noCnt = 0;
        this.carNumberCnt = new Set([]);
        this.employeeNumberCnt = new Set([]);
        this.minDtti = "";
        this.maxDtti = "";
        this.payFare = 0;
        this.hipassFare = 0;
        this.addFare = 0;
        this.fare = 0;
        this.workDist = 0;
        this.blankDist = 0;
        this.workTime = 0;
        this.allTime = 0;
        this.callFare = 0;
    }

    add(v) {
        this.noCnt += 1;
        this.carNumberCnt.add(v.carNum);
        this.employeeNumberCnt.add(v.driverId);
        this.minDtti = (this.minDtti === "" || v.minDtti < this.minDtti ) ? v.minDtti : this.minDtti;
        this.maxDtti = (this.maxDtti === "" || v.maxDtti > this.maxDtti) ? v.maxDtti : this.maxDtti;
        this.payFare += v.payFare;
        this.hipassFare += v.hipassFare;
        this.callFare += v.callFare;
        this.addFare += v.addFare;
        this.fare += v.fare;
        this.workDist += v.workDist;
        this.blankDist += v.blankDist;
        this.workTime += v.workTime;
        this.allTime += v.allTime;
        return this;
    }

    res() {
        let s = {
            fill: {fgColor: {rgb: "33CCCC"}},
            alignment: {horizontal: "center"},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }
        return [
            {v: `총 ${this.noCnt}건`, t: "s", s: s},
            {v: `${this.carNumberCnt.size}대`, t: "s", s: s},
            {v: `${this.employeeNumberCnt.size}명`, t: "s", s: s},
            {
                v: `${dateFormatFuncForExcel(this.minDtti, 'YYYY-MM-DD HH:mm')} ~ ${dateFormatFuncForExcel(this.maxDtti, 'YYYY-MM-DD HH:mm')}`,
                t: "s",
                s: s
            },
            {v: this.payFare, t: "n", z: "#,##0", s: s},
            {v: this.hipassFare, t: "n", z: "#,##0", s: s},
            {v: this.callFare, t: "n", z: "#,##0", s: s},
            {v: this.addFare, t: "n", z: "#,##0", s: s},
            {v: this.fare, t: "n", z: "#,##0", s: s},
            {v: meterToKilo(this.workDist), t: "n", z: '0.0', s: s},
            {v: meterToKilo(this.blankDist), t: "n", z: '0.0', s: s},
            {v: meterToKilo(this.workDist + this.blankDist), t: "n", z: '0.0', s: s},
            {v: secToDayPercent(this.workTime), t: "n", z: "[h]:mm:ss", s: s},
            {v: secToDayPercent(this.allTime - this.workTime), t: "n", z: "[h]:mm:ss", s: s},
            {v: secToDayPercent(this.allTime), t: "n", z: "[h]:mm:ss", s: s}
        ]
    }
}

class basePeriodExcelEntity {
    constructor(carNum, driverId, stDtti, edDtti, workTime, allTime, workDist, blankDist, fare, payFare, hipassFare, addFare, callFare, payType, payDtti, viewYn, allDist, blankTime ) {
        this.carNum = carNum;
        this.driverId = driverId;
        this.stDtti = stDtti;
        this.edDtti = edDtti;
        this.workTime = workTime;
        this.allTime = allTime;
        this.workDist = workDist;
        this.blankDist = blankDist;
        this.fare = fare;
        this.payFare = payFare;
        this.hipassFare = hipassFare;
        this.addFare = addFare;
        this.callFare = callFare;
        this.payType = payType;
        this.payDtti = payDtti;
        this.viewYn = viewYn;
        //this.totalDist = workDist + blankDist;
        this.allDist = allDist;
        this.blankTime = blankTime;
    }

    fromMap(no, v) {
        let s = {
            alignment: {horizontal: "center"},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }
        return [
            {v: no, t: "n", s: s},
            {v: v.carNum, t: "s", s: s},
            {v: v.driverId, t: "s", z: '@', s: s},
            {
                v: `${dateFormatFuncForExcel(v.stDtti, 'YYYY-MM-DD HH:mm:ss')} ~ ${dateFormatFuncForExcel(v.edDtti, 'YYYY-MM-DD HH:mm:ss')}`,
                t: "s",
                s: s
            },
            {v: v.payFare, t: "n", z: "#,##0", s: s},
            {v: v.hipassFare, t: "n", z: "#,##0", s: s},
            {v: v.callFare, t: "n", z: "#,##0", s: s},
            {v: v.addFare, t: "n", z: "#,##0", s: s},
            {v: v.fare, t: "n", z: "#,##0", s: s},
            {v: meterToKilo(v.workDist), t: "n", z: '0.0', s: s},
            {v: meterToKilo(v.blankDist), t: "n", z: '0.0', s: s},
            {v: meterToKilo(v.allDist), t: "n", z: '0.0', s: s},
            {v: secToDayPercent(v.workTime), t: "n", z: "[h]:mm:ss", s: s},
            {v: secToDayPercent(v.blankTime), t: "n", z: "[h]:mm:ss", s: s},
            {v: secToDayPercent(v.allTime), t: "n", z: "[h]:mm:ss", s: s}
        ]
    }

    fields() {
        let s = {
            fill: {fgColor: {rgb: "FFFF00"}},
            alignment: {horizontal: "center"},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }
        return [
            {key: "no", label: {v: "순번", t: "s", s: s}},
            {key: "carNum", label: {v: "차량번호", t: "s", s: s}},
            {key: "driverId", label: {v: "사원번호", t: "s", s: s}},
            {key: "period", label: {v: "운행기간", t: "s", s: s}},
            {key: "payFare", label: {v: "미터금액 (원)", t: "s", s: s}},
            {key: "hipassFare", label: {v: "통행요금 (원)", t: "s", s: s}},
            {key: "callFare", label: {v: "호출요금 (원)", t: "s", s: s}},
            {key: "addFare", label: {v: "추가금액 (원)", t: "s", s: s}},
            {key: "fare", label: {v: "합계금액 (원)", t: "s", s: s}},
            {key: "workDist", label: {v: "영업거리(KM)", t: "s", s: s}},
            {key: "blankDist", label: {v: "주행거리(KM)", t: "s", s: s}},
            {key: "allDist", label: {v: "총 운행거리(KM)", t: "s", s: s}},
            {key: "workTime", label: {v: "영업시간", t: "s", s: s}},
            {key: "blankTime", label: {v: "주행시간", t: "s", s: s}},
            {key: "allTime", label: {v: "근무시간", t: "s", s: s}},
        ]
    }

    cols() {
        return [
            {width: 10.0},
            {width: 15.0},
            {width: 12.0},
            {width: 35.0},
            {width: 15.0},
            {width: 15.0},
            {width: 15.0},
            {width: 15.0},
            {width: 15.0},
            {width: 15.0},
            {width: 15.0},
            {width: 15.0},
            {width: 15.0},
            {width: 17.0},
            {width: 10.0},
            {width: 10.0},
            {width: 10.0},
        ]
    }
}

class basePeriodExcelSumEntity {
    constructor() {
        this.noCnt = 0;
        this.carNumberCnt = new Set([]);
        this.employeeNumberCnt = new Set([]);
        this.startDate = "";
        this.endDate = "";
        this.payFare = 0;
        this.hipassFare = 0;
        this.addFare = 0;
        this.fare = 0;
        this.workDist = 0;
        this.blankDist = 0;
        this.workTime = 0;
        this.allTime = 0;
        this.callFare = 0;
    }

    add(v) {
        this.noCnt += 1;
        this.carNumberCnt.add(v.carNum);
        this.employeeNumberCnt.add(v.driverId);
        this.startDate = (v.stDtti < this.startDate || this.startDate === "") ? v.stDtti : this.startDate;
        this.endDate = (v.edDtti > this.endDate || this.startDate === "") ? v.edDtti : this.endDate;
        this.payFare += v.payFare;
        this.hipassFare += v.hipassFare;
        this.callFare += v.callFare;
        this.addFare += v.addFare;
        this.fare += v.fare;
        this.workDist += v.workDist;
        this.blankDist += v.blankDist;
        this.workTime += v.workTime;
        this.allTime += v.allTime;
        return this;
    }

    res() {
        let s = {
            fill: {fgColor: {rgb: "33CCCC"}},
            alignment: {horizontal: "center"},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }
        return [
            {v: `총 ${this.noCnt}건`, t: "s", s: s},
            {v: `${this.carNumberCnt.size}대`, t: "s", s: s},
            {v: `${this.employeeNumberCnt.size}명`, t: "s", s: s},
            {
                v: `${dateFormatFuncForExcel(this.startDate, 'YYYY-MM-DD HH:mm:ss')} ~ ${dateFormatFuncForExcel(this.endDate, 'YYYY-MM-DD HH:mm:ss')}`,
                t: "s",
                s: s
            },
            {v: this.payFare, t: "n", z: "#,##0", s: s},
            {v: this.hipassFare, t: "n", z: "#,##0", s: s},
            {v: this.callFare, t: "n", z: "#,##0", s: s},
            {v: this.addFare, t: "n", z: "#,##0", s: s},
            {v: this.fare, t: "n", z: "#,##0", s: s},
            {v: meterToKilo(this.workDist), t: "n", z: '0.0', s: s},
            {v: meterToKilo(this.blankDist), t: "n", z: '0.0', s: s},
            {v: meterToKilo(this.workDist + this.blankDist), t: "n", z: '0.0', s: s},
            {v: secToDayPercent(this.workTime), t: "n", z: "[h]:mm:ss", s: s},
            {v: secToDayPercent(this.allTime - this.workTime), t: "n", z: "[h]:mm:ss", s: s},
            {v: secToDayPercent(this.allTime), t: "n", z: "[h]:mm:ss", s: s}
        ]
    }
}

// 지불
class jibulExcelEntity {
    constructor(no, carNum, driverId, minDtti, maxDtti, period, allHipassFare, allAddFare, allBlankDist, allBlankTime, allCallFare, allCardPayFare, allCashPayFare, allDist, allFare, allPayFare, allTime, allWorkDist, allWorkTime) {
        this.no = no;
        this.carNum = carNum;
        this.driverId = driverId;
        this.minDtti = minDtti;
        this.maxDtti = maxDtti;
        this.period = period;
        this.allHipassFare = allHipassFare;
        this.allAddFare = allAddFare;
        this.allBlankDist = allBlankDist;
        this.allBlankTime = allBlankTime;
        this.allCallFare = allCallFare;
        this.allCardPayFare = allCardPayFare;
        this.allCashPayFare = allCashPayFare;
        this.allDist = allDist;
        this.allFare = allFare;
        this.allPayFare = allPayFare;
        this.allTime = allTime;
        this.allWorkDist = allWorkDist;
        this.allWorkTime = allWorkTime;
    }

    fromMap(no, v) {
        let s = {
            alignment: {horizontal: "center"},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }
        return [
            {v: no, t: "n", s: s},
            {v: v.carNum, t: "s", s: s},
            {v: v.driverId, t: "s", z: '@', s: s},
            {
                v: `${dateFormatFuncForExcel(v.minDtti, 'YYYY-MM-DD HH:mm')} ~ ${dateFormatFuncForExcel(v.maxDtti, 'YYYY-MM-DD HH:mm')}`,
                t: "s",
                s: s
            },
            {v: v.allCashPayFare, t: "n", z: "#,##0", s: s},
            {v: v.allCardPayFare, t: "n", z: "#,##0", s: s},
            {v: v.allPayFare, t: "n", z: "#,##0", s: s},
            {v: v.allHipassFare, t: "n", z: "#,##0", s: s},
            {v: v.allCallFare, t: "n", z: "#,##0", s: s},
            {v: v.allAddFare, t: "n", z: "#,##0", s: s},
            {v: v.allFare, t: "n", z: "#,##0", s: s},
            {v: meterToKilo(v.allWorkDist), t: "n", z: '0.0', s: s},
            {v: meterToKilo(v.allBlankDist), t: "n", z: '0.0', s: s},
            {v: meterToKilo(v.allDist), t: "n", z: '0.0', s: s},
            {v: secToDayPercent(v.allWorkTime), t: "n", z: "[h]:mm:ss", s: s},
            {v: secToDayPercent(v.allBlankTime), t: "n", z: "[h]:mm:ss", s: s},
            {v: secToDayPercent(v.allTime), t: "n", z: "[h]:mm:ss", s: s}
        ]
    }

    fields() {
        let s = {
            fill: {fgColor: {rgb: "FFFF00"}},
            alignment: {horizontal: "center"},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }
        return [
            {key: "no", label: {v: "순번", t: "s", s: s}},
            {key: "carNum", label: {v: "차량번호", t: "s", s: s}},
            {key: "driverId", label: {v: "사원번호", t: "s", s: s}},
            {key: "period", label: {v: "운행기간", t: "s", s: s}},
            {key: "allCashPayFare", label: {v: "현금 금액 (원)", t: "s", s: s}},
            {key: "allCardPayFare", label: {v: "카드 금액 (원)", t: "s", s: s}},
            {key: "allPayFare", label: {v: "현금카드 합계 (원)", t: "s", s: s}},
            {key: "allHipassFare", label: {v: "통행요금 (원)", t: "s", s: s}},
            {key: "allCallFare", label: {v: "호출요금 (원)", t: "s", s: s}},
            {key: "allAddFare", label: {v: "추가금액 (원)", t: "s", s: s}},
            {key: "allFare", label: {v: "합계금액 (원)", t: "s", s: s}},
            {key: "allWorkDist", label: {v: "영업거리(KM)", t: "s", s: s}},
            {key: "allEmptyDist", label: {v: "주행거리(KM)", t: "s", s: s}},
            {key: "allBlankDist", label: {v: "총 운행거리(KM)", t: "s", s: s}},
            {key: "allWorkTime", label: {v: "영업시간", t: "s", s: s}},
            {key: "allBlankTime", label: {v: "주행시간", t: "s", s: s}},
            {key: "allTime", label: {v: "근무시간", t: "s", s: s}},
        ]
    }

    cols() {
        return [
            {width: 10.0},
            {width: 15.0},
            {width: 12.0},
            {width: 35.0},
            {width: 17.0},
            {width: 17.0},
            {width: 20.0},
            {width: 17.0},
            {width: 17.0},
            {width: 17.0},
            {width: 17.0},
            {width: 17.0},
            {width: 17.0},
            {width: 17.0},
            {width: 10.0},
            {width: 10.0},
            {width: 10.0},
        ]
    }
}

class jibulExcelSumEntity {
    constructor() {
        this.noCnt = 0;
        this.carNumberCnt = new Set([]);
        this.employeeNumberCnt = new Set([]);
        this.startDate = "";
        this.endDate = "";
        this.allHipassFare = 0;
        this.allAddFare = 0;
        this.allBlankDist = 0;
        this.allBlankTime = 0;
        this.allCallFare = 0;
        this.allCardPayFare = 0;
        this.allCashPayFare = 0;
        this.allDist = 0;
        this.allFare = 0;
        this.allPayFare = 0;
        this.allTime = 0;
        this.allWorkDist = 0;
        this.allWorkTime = 0;
    }

    add(v) {
        this.noCnt += 1;
        this.carNumberCnt.add(v.carNum);
        this.employeeNumberCnt.add(v.driverId);
        this.startDate = (v.minDtti < this.startDate || this.startDate === "") ? v.minDtti : this.startDate;
        this.endDate = (v.maxDtti > this.endDate || this.startDate === "") ? v.maxDtti : this.endDate;
        this.allHipassFare += v.allHipassFare;
        this.allAddFare += v.allAddFare;
        this.allBlankDist += v.allBlankDist;
        this.allBlankTime += v.allBlankTime;
        this.allCallFare += v.allCallFare;
        this.allCardPayFare += v.allCardPayFare;
        this.allCashPayFare += v.allCashPayFare;
        this.allDist += v.allDist;
        this.allFare += v.allFare;
        this.allPayFare += v.allPayFare;
        this.allTime += v.allTime;
        this.allWorkDist += v.allWorkDist;
        this.allWorkTime += v.allWorkTime;
        return this;
    }

    res() {
        let s = {
            fill: {fgColor: {rgb: "33CCCC"}},
            alignment: {horizontal: "center"},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }
        return [
            {v: `총 ${this.noCnt}건`, t: "s", s: s},
            {v: `${this.carNumberCnt.size}대`, t: "s", s: s},
            {v: `${this.employeeNumberCnt.size}명`, t: "s", s: s},
            {
                v: `${dateFormatFuncForExcel(this.startDate, 'YYYY-MM-DD HH:mm')} ~ ${dateFormatFuncForExcel(this.endDate, 'YYYY-MM-DD HH:mm')}`,
                t: "s",
                s: s
            },
            {v: this.allCashPayFare, t: "n", z: "#,##0", s: s},
            {v: this.allCardPayFare, t: "n", z: "#,##0", s: s},
            {v: this.allPayFare, t: "n", z: "#,##0", s: s},
            {v: this.allHipassFare, t: "n", z: "#,##0", s: s},
            {v: this.allCallFare, t: "n", z: "#,##0", s: s},
            {v: this.allAddFare, t: "n", z: "#,##0", s: s},
            {v: this.allFare, t: "n", z: "#,##0", s: s},
            {v: meterToKilo(this.allWorkDist), t: "n", z: '0.0', s: s},
            {v: meterToKilo(this.allBlankDist), t: "n", z: '0.0', s: s},
            {v: meterToKilo(this.allDist), t: "n", z: '0.0', s: s},
            {v: secToDayPercent(this.allWorkTime), t: "n", z: "[h]:mm:ss", s: s},
            {v: secToDayPercent(this.allBlankTime), t: "n", z: "[h]:mm:ss", s: s},
            {v: secToDayPercent(this.allTime), t: "n", z: "[h]:mm:ss", s: s}
        ]
    }
}

class jibulPeriodExcelEntity {
    fromMap(no, v) {
        let s = {
            alignment: {horizontal: "center"},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }
        return [
            {v: no, t: "n", s: s},
            {v: v.carNum, t: "s", s: s},
            {v: v.driverId, t: "s", z: '@', s: s},
            {
                v: `${dateFormatFuncForExcel(v.stDtti, 'YYYY-MM-DD HH:mm:ss')} ~ ${dateFormatFuncForExcel(v.edDtti, 'YYYY-MM-DD HH:mm:ss')}`,
                t: "s",
                s: s
            },
            {v: v.cashFare, t: "n", z: "#,##0", s: s},
            {v: v.cardFare, t: "n", z: "#,##0", s: s},
            {v: v.fare - (v.hipassFare + v.callFare + v.addFare), t: "n", z: "#,##0", s: s},
            {v: v.hipassFare, t: "n", z: "#,##0", s: s},
            {v: v.callFare, t: "n", z: "#,##0", s: s},
            {v: v.addFare, t: "n", z: "#,##0", s: s},
            {v: v.fare, t: "n", z: "#,##0", s: s},
            {v: meterToKilo(v.workDist), t: "n", z: '0.0', s: s},
            {v: meterToKilo(v.blankDist), t: "n", z: '0.0', s: s},
            {v: meterToKilo(v.workDist + v.blankDist), t: "n", z: '0.0', s: s},
            {v: secToDayPercent(v.workTime), t: "n", z: "[h]:mm:ss", s: s},
            {v: secToDayPercent(v.allTime - v.workTime), t: "n", z: "[h]:mm:ss", s: s},
            {v: secToDayPercent(v.allTime), t: "n", z: "[h]:mm:ss", s: s}
        ]
    }

    fields() {
        let s = {
            fill: {fgColor: {rgb: "FFFF00"}},
            alignment: {horizontal: "center"},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }
        return [
            {key: "no", label: {v: "순번", t: "s", s: s}},
            {key: "carNum", label: {v: "차량번호", t: "s", s: s}},
            {key: "driverId", label: {v: "사원번호", t: "s", s: s}},
            {key: "period", label: {v: "운행기간", t: "s", s: s}},
            {key: "cashFare", label: {v: "현금금액 (원)", t: "s", s: s}},
            {key: "cardFare", label: {v: "카드금액 (원)", t: "s", s: s}},
            {key: "allPayFare", label: {v: "현금카드 합계 (원)", t: "s", s: s}},
            {key: "allHipassFare", label: {v: "통행요금 (원)", t: "s", s: s}},
            {key: "allCallFare", label: {v: "호출요금 (원)", t: "s", s: s}},
            {key: "allAddFare", label: {v: "추가금액 (원)", t: "s", s: s}},
            {key: "allFare", label: {v: "합계금액 (원)", t: "s", s: s}},
            {key: "allWorkDist", label: {v: "영업거리(KM)", t: "s", s: s}},
            {key: "allEmptyDist", label: {v: "주행거리(KM)", t: "s", s: s}},
            {key: "allBlankDist", label: {v: "총 운행거리(KM)", t: "s", s: s}},
            {key: "allWorkTime", label: {v: "영업시간", t: "s", s: s}},
            {key: "allBlankTime", label: {v: "주행시간", t: "s", s: s}},
            {key: "allTime", label: {v: "근무시간", t: "s", s: s}},
        ]
    }

    cols() {
        return [
            {width: 10.0},
            {width: 15.0},
            {width: 12.0},
            {width: 35.0},
            {width: 17.0},
            {width: 17.0},
            {width: 20.0},
            {width: 17.0},
            {width: 17.0},
            {width: 17.0},
            {width: 17.0},
            {width: 17.0},
            {width: 17.0},
            {width: 17.0},
            {width: 10.0},
        ]
    }
}

class jibulPeriodExcelSumEntity {
    constructor() {
        this.noCnt = 0;
        this.carNumberCnt = new Set([]);
        this.employeeNumberCnt = new Set([]);
        this.startDate = "";
        this.endDate = "";
        this.allHipassFare = 0;
        this.allAddFare = 0;
        this.allBlankDist = 0;
        this.allBlankTime = 0;
        this.allCallFare = 0;
        this.allCardPayFare = 0;
        this.allCashPayFare = 0;
        this.allDist = 0;
        this.allFare = 0;
        this.allPayFare = 0;
        this.allTime = 0;
        this.allWorkDist = 0;
        this.allWorkTime = 0;
    }

    add(v) {
        this.noCnt += 1;
        this.carNumberCnt.add(v.carNum);
        this.employeeNumberCnt.add(v.driverId);
        this.startDate = (v.stDtti < this.startDate || this.startDate === "") ? v.stDtti : this.startDate;
        this.endDate = (v.edDtti > this.endDate || this.startDate === "") ? v.edDtti : this.endDate;
        this.allHipassFare += v.hipassFare;
        this.allAddFare += v.addFare;
        this.allBlankDist += v.blankDist;
        this.allBlankTime += (v.allTime - v.workTime);
        this.allCallFare += v.callFare;
        this.allCardPayFare += v.cardFare;
        this.allCashPayFare += v.cashFare;
        this.allDist += (v.workDist + v.blankDist);
        this.allFare += v.fare;
        this.allPayFare += v.fare - (v.hipassFare + v.callFare + v.addFare);
        this.allTime += v.allTime;
        this.allWorkDist += v.workDist;
        this.allWorkTime += v.workTime;
        return this;
    }

    res() {
        let s = {
            fill: {fgColor: {rgb: "33CCCC"}},
            alignment: {horizontal: "center"},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }
        return [
            {v: `총 ${this.noCnt}건`, t: "s", s: s},
            {v: `${this.carNumberCnt.size}대`, t: "s", s: s},
            {v: `${this.employeeNumberCnt.size}명`, t: "s", s: s},
            {
                v: `${dateFormatFuncForExcel(this.startDate, 'YYYY-MM-DD HH:mm:ss')} ~ ${dateFormatFuncForExcel(this.endDate, 'YYYY-MM-DD HH:mm:ss')}`,
                t: "s",
                s: s
            },
            {v: this.allCashPayFare, t: "n", z: "#,##0", s: s},
            {v: this.allCardPayFare, t: "n", z: "#,##0", s: s},
            {v: this.allCashPayFare + this.allCardPayFare, t: "n", z: "#,##0", s: s},
            {v: this.allHipassFare, t: "n", z: "#,##0", s: s},
            {v: this.allCallFare, t: "n", z: "#,##0", s: s},
            {v: this.allAddFare, t: "n", z: "#,##0", s: s},
            {v: this.allFare, t: "n", z: "#,##0", s: s},
            {v: meterToKilo(this.allWorkDist), t: "n", z: '0.0', s: s},
            {v: meterToKilo(this.allBlankDist), t: "n", z: '0.0', s: s},
            {v: meterToKilo(this.allDist), t: "n", z: '0.0', s: s},
            {v: secToDayPercent(this.allWorkTime), t: "n", z: "[h]:mm:ss", s: s},
            {v: secToDayPercent(this.allBlankTime), t: "n", z: "[h]:mm:ss", s: s},
            {v: secToDayPercent(this.allTime), t: "n", z: "[h]:mm:ss", s: s}
        ]
    }
}

// 세계
class segyeExcelEntity {
    constructor(no, carNum, driverId, driverName, period, fare, workDist, blankDist, workTime, allTime, allDist, blankTime) {
        this.no = no;
        this.carNum = carNum;
        this.driverId = driverId;
        this.driverName = driverName;
        this.period = period
        this.fare = fare;
        this.workDist = workDist;
        this.blankDist = blankDist;
        this.workTime = workTime;
        this.allTime = allTime;
        this.allDist = allDist;
        this.blankTime = blankTime;
    }

    cols() {
        return [
            {width: 10.0},
            {width: 15.0},
            {width: 12.0},
            {width: 12.0},
            {width: 35.0},
            {width: 15.0},
            {width: 15.0},
            {width: 15.0},
            {width: 17.0},
            {width: 10.0},
            {width: 10.0},
            {width: 10.0},
        ]
    }

    fromMap(no, v) {
        let s = {
            alignment: {horizontal: "center"},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }
        return [
            {v: no, t: "n", s: s},
            {v: v.carNum, t: "s", s: s},
            {v: v.driverId, t: "s", z: '@', s: s},
            {v: v.driverName, t: "s", s: s},
            {
                v: `${dateFormatFuncForExcel(v.minDtti, 'YYYY-MM-DD HH:mm')} ~ ${dateFormatFuncForExcel(v.maxDtti, 'YYYY-MM-DD HH:mm')}`,
                t: "s",
                s: s
            },
            {v: v.fare, t: "n", z: "#,##0", s: s},
            {v: meterToKilo(v.workDist), t: "n", z: '0.0', s: s},
            {v: meterToKilo(v.blankDist), t: "n", z: '0.0', s: s},
            //{v: meterToKilo(v.workDist + v.blankDist), t: "n", z: '0.0 ,s: s},
            {v: meterToKilo(v.allDist), t: "n", z: '0.0', s: s},
            {v: secToDayPercent(v.workTime), t: "n", z: "[h]:mm:ss", s: s},
            //{v: secToDayPercent(v.allTime - v.workTime), t: "n", z: "[h]:mm:ss", s: s},
            {v: secToDayPercent(v.blankTime), t: "n", z: "[h]:mm:ss", s: s},
            {v: secToDayPercent(v.allTime), t: "n", z: "[h]:mm:ss", s: s}
        ]
    }

    fields() {
        let s = {
            fill: {fgColor: {rgb: "FFFF00"}},
            alignment: {horizontal: "center"},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }
        return [
            {key: "no", label: {v: "순번", t: "s", s: s}},
            {key: "carNum", label: {v: "차량번호", t: "s", s: s}},
            {key: "driverId", label: {v: "사원번호", t: "s", s: s}},
            {key: "driverName", label: {v: "기사명", t: "s", s: s}},
            {key: "period", label: {v: "운행시작~운행종료", t: "s", s: s}},
            {key: "fare", label: {v: "미터수입금(원)", t: "s", s: s}},
            {key: "workDist", label: {v: "영업거리(KM)", t: "s", s: s}},
            {key: "emptyDist", label: {v: "주행거리(KM)", t: "s", s: s}},
            //{key: "totalDist", label: {v: "총 운행거리(KM)", t: "s", s: s}},
            {key: "allDist", label: {v: "총 운행거리(KM)", t: "s", s: s}},
            {key: "workTime", label: {v: "영업시간", t: "s", s: s}},
            {key: "blankTime", label: {v: "주행시간", t: "s", s: s}},
            {key: "allTime", label: {v: "근무시간", t: "s", s: s}},
        ]
    }
}

class segyeExcelSumEntity {
    constructor() {
        this.noCnt = 0;
        this.carNumberCnt = new Set([]);
        this.employeeNumberCnt = new Set([]);
        this.startDate = "";
        this.endDate = "";
        this.fare = 0;
        this.workDist = 0;
        this.blankDist = 0;
        this.workTime = 0;
        this.allTime = 0;
    }

    add(v) {
        this.noCnt += 1;
        this.carNumberCnt.add(v.carNum);
        this.employeeNumberCnt.add(v.driverId);
        this.startDate = (v.minDtti < this.startDate || this.startDate === "") ? v.minDtti : this.startDate;
        this.endDate = (v.maxDtti > this.endDate || this.startDate === "") ? v.maxDtti : this.endDate;
        this.fare += v.fare;
        this.workDist += v.workDist;
        this.blankDist += v.blankDist;
        this.workTime += v.workTime;
        this.allTime += v.allTime;
        return this;
    }

    res() {
        let s = {
            fill: {fgColor: {rgb: "33CCCC"}},
            alignment: {horizontal: "center"},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }
        return [
            {v: `총 ${this.noCnt}건`, t: "s", s: s},
            {v: `${this.carNumberCnt.size}대`, t: "s", s: s},
            {v: `${this.employeeNumberCnt.size}명`, t: "s", s: s},
            {v: "", t: "s", s: s},
            {
                v: `${dateFormatFuncForExcel(this.startDate, 'YYYY-MM-DD HH:mm')} ~ ${dateFormatFuncForExcel(this.endDate, 'YYYY-MM-DD HH:mm')}`,
                t: "s",
                s: s
            },
            {v: this.fare, t: "n", z: "#,##0", s: s},
            {v: meterToKilo(this.workDist), t: "n", z: '0.0', s: s},
            {v: meterToKilo(this.blankDist), t: "n", z: '0.0', s: s},
            {v: meterToKilo(this.workDist + this.blankDist), t: "n", z: '0.0', s: s},
            {v: secToDayPercent(this.workTime), t: "n", z: "[h]:mm:ss", s: s},
            {v: secToDayPercent(this.allTime - this.workTime), t: "n", z: "[h]:mm:ss", s: s},
            {v: secToDayPercent(this.allTime), t: "n", z: "[h]:mm:ss", s: s}
        ]
    }
}

class segyePeriodExcelEntity {
    constructor(no, carNum, driverId, driverName, period, fare, workDist, blankDist, workTime, allTime, allDist, blankTime ,cardFare, cashFare) {
        this.no = no;
        this.carNum = carNum;
        this.driverId = driverId;
        this.driverName = driverName;
        this.period = period
        this.fare = fare;
        this.workDist = workDist;
        this.blankDist = blankDist;
        this.workTime = workTime;
        this.allTime = allTime;
        this.allDist = allDist;
        this.blankTime = blankTime;
        this.cardFare = cardFare;
        this.cashFare = cashFare;
    }

    cols() {
        return [
            {width: 10.0},
            {width: 15.0},
            {width: 12.0},
            {width: 12.0},
            {width: 35.0},
            {width: 15.0},
            {width: 15.0},
            {width: 15.0},
            {width: 17.0},
            {width: 17.0},
            {width: 17.0},
            {width: 10.0},
            {width: 10.0},
            {width: 10.0},
        ]
    }

    fromMap(no, v) {
        let s = {
            alignment: {horizontal: "center"},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }
        return [
            {v: no, t: "n", s: s},
            {v: v.carNum, t: "s", s: s},
            {v: v.driverId, t: "s", z: '@', s: s},
            {v: v.driverName, t: "s", s: s},
            {
                v: `${dateFormatFuncForExcel(v.stDtti, 'YYYY-MM-DD HH:mm')} ~ ${dateFormatFuncForExcel(v.edDtti, 'YYYY-MM-DD HH:mm')}`,
                t: "s",
                s: s
            },
            {v: (v.fare - v.addFare - v.hipassFare), t: "n", z: "#,##0", s: s},
            {v: (v.cashFare), t: "n", z: "#,##0", s: s},
            {v: (v.cardFare), t: "n", z: "#,##0", s: s},
            {v: meterToKilo(v.workDist), t: "n", z: '0.0', s: s},
            {v: meterToKilo(v.blankDist), t: "n", z: '0.0', s: s},
            {v: meterToKilo(v.allDist), t: "n", z: '0.0', s: s},
            {v: secToDayPercent(v.workTime), t: "n", z: "[h]:mm", s: s},
            {v: secToDayPercent(v.blankTime), t: "n", z: "[h]:mm", s: s},
            {v: secToDayPercent(v.allTime), t: "n", z: "[h]:mm", s: s}
        ]
    }

    fields() {
        let s = {
            fill: {fgColor: {rgb: "FFFF00"}},
            alignment: {horizontal: "center"},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }
        return [
            {key: "no", label: {v: "순번", t: "s", s: s}},
            {key: "carNum", label: {v: "차량번호", t: "s", s: s}},
            {key: "driverId", label: {v: "사원번호", t: "s", s: s}},
            {key: "driverName", label: {v: "기사명", t: "s", s: s}},
            {key: "period", label: {v: "운행시작~운행종료", t: "s", s: s}},
            {key: "fare", label: {v: "미터수입금(원)", t: "s", s: s}},
            {key: "cashFare", label: {v: "현금금액(원)", t: "s", s: s}},
            {key: "cardFare", label: {v: "카드금액(원)", t: "s", s: s}},
            {key: "workDist", label: {v: "영업거리(KM)", t: "s", s: s}},
            {key: "emptyDist", label: {v: "주행거리(KM)", t: "s", s: s}},
            //{key: "totalDist", label: {v: "총 운행거리(KM)", t: "s", s: s}},
            {key: "allDist", label: {v: "총 운행거리(KM)", t: "s", s: s}},
            {key: "workTime", label: {v: "영업시간", t: "s", s: s}},
            {key: "blankTime", label: {v: "주행시간", t: "s", s: s}},
            {key: "allTime", label: {v: "근무시간", t: "s", s: s}},
        ]
    }
}

class segyePeriodExcelSumEntity {
    constructor() {
        this.noCnt = 0;
        this.carNumberCnt = new Set([]);
        this.employeeNumberCnt = new Set([]);
        this.startDate = "";
        this.endDate = "";
        this.segyeFare = 0;
        this.cardFare = 0;
        this.cashFare = 0;
        this.workDist = 0;
        this.blankDist = 0;
        this.workTime = 0;
        this.allTime = 0;
    }

    add(v) {
        this.noCnt += 1;
        this.carNumberCnt.add(v.carNum);
        this.employeeNumberCnt.add(v.driverId);
        this.startDate = (v.stDtti < this.startDate || this.startDate === "") ? v.stDtti : this.startDate;
        this.endDate = (v.edDtti > this.endDate || this.startDate === "") ? v.edDtti : this.endDate;
        this.segyeFare += (v.fare - v.addFare - v.hipassFare);
        this.workDist += v.workDist;
        this.blankDist += v.blankDist;
        this.workTime += v.workTime;
        this.allTime += v.allTime;
        this.cardFare += parseInt(v.cardFare);
        this.cashFare += parseInt(v.cashFare);

        return this;
    }

    res() {
        let s = {
            fill: {fgColor: {rgb: "33CCCC"}},
            alignment: {horizontal: "center"},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }
        return [
            {v: `총 ${this.noCnt}건`, t: "s", s: s},
            {v: `${this.carNumberCnt.size}대`, t: "s", s: s},
            {v: `${this.employeeNumberCnt.size}명`, t: "s", s: s},
            {v: "", t: "s", s: s},
            {
                v: `${dateFormatFuncForExcel(this.startDate, 'YYYY-MM-DD HH:mm')} ~ ${dateFormatFuncForExcel(this.endDate, 'YYYY-MM-DD HH:mm')}`,
                t: "s",
                s: s
            },
            {v: this.segyeFare, t: "n", z: "#,##0", s: s},
            {v: this.cashFare, t: "n", z: "#,##0", s: s},
            {v: this.cardFare, t: "n", z: "#,##0", s: s},
            {v: meterToKilo(this.workDist), t: "n", z: '0.0', s: s},
            {v: meterToKilo(this.blankDist), t: "n", z: '0.0', s: s},
            {v: meterToKilo(this.workDist + this.blankDist), t: "n", z: '0.0', s: s},
            {v: secToDayPercent(this.workTime), t: "n", z: "[h]:mm", s: s},
            {v: secToDayPercent(this.allTime - this.workTime), t: "n", z: "[h]:mm", s: s},
            {v: secToDayPercent(this.allTime), t: "n", z: "[h]:mm", s: s}
        ]
    }
}

class aggregateDetailExcelEntity {
    constructor(carNum, driverId, minDtti, maxDtti, workTime, allTime, workDist, blankDist, fare, payFare, hipassFare, addFare, callFare, payType, payDtti, viewYn) {
        this.carNum = carNum;
        this.driverId = driverId;
        this.minDtti = minDtti;
        this.maxDtti = maxDtti;
        this.workTime = workTime;
        this.allTime = allTime;
        this.workDist = workDist;
        this.blankDist = blankDist;
        this.fare = fare;
        this.payFare = payFare;
        this.hipassFare = hipassFare;
        this.addFare = addFare;
        this.callFare = callFare;
        this.payType = payType;
        this.payDtti = payDtti;
        this.viewYn = viewYn;
    }

    cols() {
        return [
            {width: 10.0},
            {width: 15.0},
            {width: 12.0},
            {width: 35.0},
            {width: 12.0},
            {width: 15.0},
            {width: 15.0},
            {width: 15.0},
            {width: 17.0},
            {width: 17.0},
            {width: 17.0},
            {width: 10.0},
            {width: 25.0},
        ]
    }

    fromMap(no, v) {
        let s = {
            alignment: {horizontal: "center"},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }
        return [
            {v: no, t: "n", s: s},
            {v: v.carNum, t: "s", s: s},
            {v: v.driverId, t: "s", z: '@', s: s},
            {
                v: `${dateFormatFuncForExcel(v.minDtti, 'YYYY-MM-DD HH:mm:ss')} ~ ${dateFormatFuncForExcel(v.maxDtti, 'YYYY-MM-DD HH:mm:ss')}`,
                t: "s",
                s: s
            },
            {v: secToDayPercent(v.workTime), t: "n", z: "[h]:mm:ss", s: s},
            {v: meterToKilo(v.workDist), t: "n", z: '0.0', s: s},
            {v: v.payFare, t: "n", z: "#,##0", s: s},
            {v: v.hipassFare, t: "n", z: "#,##0", s: s},
            {v: v.callFare, t: "n", z: "#,##0", s: s},
            {v: v.addFare, t: "n", z: "#,##0", s: s},
            {v: v.fare, t: "n", z: "#,##0", s: s},
            {v: tachoEntity.paymentTypeEnum[v.payType], t: "s", s: s},
            {v: dateFormatFuncForExcel(v.payDtti, 'YYYY-MM-DD HH:mm:ss'), t: "s", s: s}
        ]
    }

    fields() {
        let s = {
            fill: {fgColor: {rgb: "FFFF00"}},
            alignment: {horizontal: "center"},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }
        return [
            {key: "no", label: {v: "순번", t: "s", s: s}},
            {key: "carNum", label: {v: "차량번호", t: "s", s: s}},
            {key: "driverId", label: {v: "사원번호", t: "s", s: s}},
            {key: "period", label: {v: "운행기간", t: "s", s: s}},
            {key: "onTime", label: {v: "운행시간", t: "s", s: s}},
            {key: "onDist", label: {v: "운행거리", t: "s", s: s}},
            {key: "payFare", label: {v: "미터금액", t: "s", s: s}},
            {key: "hipassFare", label: {v: "통행요금", t: "s", s: s}},
            {key: "callFare", label: {v: "호출요금", t: "s", s: s}},
            {key: "addFare", label: {v: "추가금액", t: "s", s: s}},
            {key: "fare", label: {v: "합계금액", t: "s", s: s}},
            {key: "payType", label: {v: "결제타입", t: "s", s: s}},
            {key: "payDate", label: {v: "결제시간", t: "s", s: s}},
        ]
    }
}


class drivingPrivatePerMinuteExcelEntity {
    constructor(infoDtti, officeId, carNum, driverId, speed, dist, carX, carY, viewYn, apiDtti) {
        this.infoDtti = infoDtti,
            this.officeId = officeId,
            this.carNum = carNum,
            this.driverId = driverId,
            this.speed = speed,
            this.dist = dist,
            this.carX = carX,
            this.carY = carY,
            this.viewYn = viewYn,
            this.apiDtti = apiDtti
    }

    fromMap(no, v) {
        let s = {
            alignment: {horizontal: "center"},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }
        return [
            {v: no, t: "n", s: s},
            {v: `${dateFormatFuncForExcel(v.infoDtti, 'YYYY-MM-DD HH:mm:ss')}`, t: "s", s: s},
            {v: v.officeId, t: "s", s: s},
            {v: v.carNum, t: "s", s: s},
            {v: v.driverId, t: "s", z: '@', s: s},
            {v: v.speed, t: "s", s: s},
            {v: meterToKilo(v.dist), t: "n", z: "0.0", s: s},
            {v: Math.round(v.carX * 1000)/1000, t: "s", s: s},
            {v: Math.round(v.carY * 1000)/1000, t: "s", s: s},
            {v: `${dateFormatFuncForExcel(v.apiDtti, 'YYYY-MM-DD HH:mm:ss')}`, t: "s", s: s},

        ]
    }

    fields() {
        let s = {
            fill: {fgColor: {rgb: "FFFF00"}},
            alignment: {horizontal: "center"},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }
        return [
            {key: "no", label: {v: "순번", t: "s", s: s}},
            {key: "infoDtti", label: {v: "데이터 생성일시", t: "s", s: s}},
            {key: "officeId", label: {v: "사업자번호", t: "s", s: s}},
            {key: "carNum", label: {v: "차량번호", t: "s", s: s}},
            {key: "driverId", label: {v: "사원번호", t: "s", s: s}},
            {key: "speed", label: {v: "속도 (KM)", t: "s", s: s}},
            {key: "dist", label: {v: "거리 (KM)", t: "s", s: s}},
            {key: "carX", label: {v: "위치 (X좌표)", t: "s", s: s}},
            {key: "carY", label: {v: "위치 (Y좌표)", t: "s", s: s}},
            {key: "apiDtti", label: {v: "데이터 저장일시", t: "s", s: s}}
        ]
    }

    cols() {
        return [
            {width: 10.0},
            {width: 35.0},
            {width: 12.0},
            {width: 15.0},
            {width: 12.0},
            {width: 15.0},
            {width: 15.0},
            {width: 15.0},
            {width: 15.0},
            {width: 35.0}
        ]
    }
}

class drivingPerMinuteExcelEntity {
    constructor(infoDtti, officeId, carNum, driverId, speed, dist, carX, carY, viewYn, apiDtti,avgSpeed, status) {
        this.infoDtti = infoDtti,
        this.officeId = officeId,
        this.carNum = carNum,
        this.driverId = driverId,
        this.speed = speed,
        this.dist = dist,
        this.carX = carX,
        this.carY = carY,
        this.viewYn = viewYn,
        this.apiDtti = apiDtti,
        this.avgSpeed = avgSpeed,
        this.status = status
    }

    fromMap(no, v) {
        let s = {
            alignment: {horizontal: "center"},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }
        return [
            {v: no, t: "n", s: s},
            {v: `${dateFormatFuncForExcel(v.infoDtti, 'YYYY-MM-DD HH:mm:ss')}`, t: "s", s: s},
            {v: v.officeId, t: "s", s: s},
            {v: v.carNum, t: "s", s: s},
            {v: v.driverId, t: "s", z: '@', s: s},
            {v: v.speed, t: "s", s: s},
            {v: v.avgSpeed, t: "n", s: s},
            {v: v.status, t: "n", s: s},
            {v: meterToKilo(v.dist), t: "n", z: "0.0", s: s},
            {v: Math.round(v.carX * 1000)/1000, t: "s", s: s},
            {v: Math.round(v.carY * 1000)/1000, t: "s", s: s},
            {v: `${dateFormatFuncForExcel(v.apiDtti, 'YYYY-MM-DD HH:mm:ss')}`, t: "s", s: s},

        ]
    }

    fields() {
        let s = {
            fill: {fgColor: {rgb: "FFFF00"}},
            alignment: {horizontal: "center"},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }
        return [
            {key: "no", label: {v: "순번", t: "s", s: s}},
            {key: "infoDtti", label: {v: "데이터 생성일시", t: "s", s: s}},
            {key: "officeId", label: {v: "사업자번호", t: "s", s: s}},
            {key: "carNum", label: {v: "차량번호", t: "s", s: s}},
            {key: "driverId", label: {v: "사원번호", t: "s", s: s}},
            {key: "speed", label: {v: "속도 (KM)", t: "s", s: s}},
            {key: "avgSpeed", label: {v: "평균속도 (KM)", t: "s", s: s}},
            {key: "status",label: {v: "상태 코드", t: "s", s: s}},
            {key: "dist", label: {v: "거리 (KM)", t: "s", s: s}},
            {key: "carX", label: {v: "위치 (X좌표)", t: "s", s: s}},
            {key: "carY", label: {v: "위치 (Y좌표)", t: "s", s: s}},
            {key: "apiDtti", label: {v: "데이터 저장일시", t: "s", s: s}}
        ]
    }

    cols() {
        return [
            {width: 10.0},
            {width: 35.0},
            {width: 12.0},
            {width: 15.0},
            {width: 12.0},
            {width: 15.0},
            {width: 15.0},
            {width: 15.0},
            {width: 15.0},
            {width: 15.0},
            {width: 15.0},
            {width: 35.0}
        ]
    }
}

// 기본
class baseCloseExcelEntity {
    constructor(carNum, driverId, stDtti, edDtti, workTime, allTime, workDist, blankDist, allFare, payFare, hipassFare, calFare, addFare, callFare, allDist, blankTime ) {
        this.carNum = carNum;
        this.driverId = driverId;
        this.stDtti = stDtti;
        this.edDtti = edDtti;
        this.workTime = workTime;
        this.allTime = allTime;
        this.workDist = workDist;
        this.blankDist = blankDist;
        this.allFare = allFare;
        this.payFare = payFare;
        this.hipassFare = hipassFare;
        this.callFare = callFare;
        this.addFare = addFare;
        this.allDist = allDist;
        this.blankTime = blankTime;
    }

    fromMap(no, v) {
        let s = {
            alignment: {horizontal: "center"},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }
        return [
            {v: no, t: "n", s: s},
            {v: v.carNum, t: "s", s: s},
            {v: v.driverId, t: "s", z: '@', s: s},
            {
                v: `${dateFormatFuncForExcel(v.stDtti, 'YYYY-MM-DD HH:mm:ss')} ~ ${dateFormatFuncForExcel(v.edDtti, 'YYYY-MM-DD HH:mm:ss')}`,
                t: "s",
                s: s
            },
            {v: v.payFare, t: "n", z: "#,##0", s: s},
            {v: v.hipassFare, t: "n", z: "#,##0", s: s},
            {v: v.callFare, t: "n", z: "#,##0", s: s},
            {v: parseInt(v.addFare), t: "n", z: "#,##0", s: s},
            {v: v.allFare, t: "n", z: "#,##0", s: s},
            {v: meterToKilo(v.workDist), t: "n", z: "0.0", s: s},
            {v: meterToKilo(v.blankDist), t: "n", z: "0.0", s: s},
            {v: meterToKilo(v.allDist), t: "n", z: "0.0", s: s},
            {v: secToDayPercent(v.workTime), t: "n", z: "[h]:mm:ss", s: s},
            {v: secToDayPercent(v.blankTime), t: "n", z: "[h]:mm:ss", s: s},
            {v: secToDayPercent(v.allTime), t: "n", z: "[h]:mm:ss", s: s}
        ]
    }

    fields() {
        let s = {
            fill: {fgColor: {rgb: "FFFF00"}},
            alignment: {horizontal: "center"},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }
        return [
            {key: "no", label: {v: "순번", t: "s", s: s}},
            {key: "carNum", label: {v: "차량번호", t: "s", s: s}},
            {key: "driverId", label: {v: "사원번호", t: "s", s: s}},
            {key: "period", label: {v: "운행기간", t: "s", s: s}},
            {key: "payFare", label: {v: "미터금액 (원)", t: "s", s: s}},
            {key: "hipassFare", label: {v: "통행요금 (원)", t: "s", s: s}},
            {key: "callFare", label: {v: "호출요금 (원)", t: "s", s: s}},
            {key: "addFare", label: {v: "추가금액 (원)", t: "s", s: s}},
            {key: "allFare", label: {v: "합계금액 (원)", t: "s", s: s}},
            {key: "workDist", label: {v: "영업거리(KM)", t: "s", s: s}},
            {key: "blankDist", label: {v: "주행거리(KM)", t: "s", s: s}},
            {key: "allDist", label: {v: "총 운행거리(KM)", t: "s", s: s}},
            {key: "workTime", label: {v: "영업시간", t: "s", s: s}},
            {key: "blankTime", label: {v: "주행시간", t: "s", s: s}},
            {key: "allTime", label: {v: "근무시간", t: "s", s: s}},
        ]
    }

    cols() {
        return [
            {width: 10.0},
            {width: 15.0},
            {width: 12.0},
            {width: 35.0},
            {width: 15.0},
            {width: 15.0},
            {width: 15.0},
            {width: 15.0},
            {width: 15.0},
            {width: 15.0},
            {width: 15.0},
            {width: 15.0},
            {width: 15.0},
            {width: 17.0},
            {width: 10.0},
            {width: 10.0},
            {width: 10.0},
        ]
    }
}

class excelTachoVoucherDto {
    constructor(carNum, driverId, stDtti, edDtti , payStartDtti, distFare, addFare, hipassFee, voucherDiscount, payTotal, tripDist ,payType, callFee) {

        this.carNum = carNum;
        this.driverId = driverId;
        this.stDtti = stDtti;
        this.edDtti = edDtti;
        this.payStartDtti = payStartDtti;
        this.distFare = distFare;
        this.addFare = addFare;
        this.callFee = callFee;
        this.hipassFee = hipassFee;
        this.voucherDiscount = voucherDiscount;
        this.payTotal = payTotal;
        this.tripDist = tripDist;
        this.payType = payType;

    }
    cols() {
        return [
            {width: 10.0},      //순번
            {width: 15.0},      //사원번호
            {width: 15.0},      //차량번호
            {width: 25.0},      //운행시작
            {width: 25.0},      //운행종료
            {width: 12.0},      //운행거리
            {width: 15.0},      //승차요금
            {width: 15.0},      //할인요금
            {width: 15.0},      //통행요금
            {width: 15.0},      //호출요금
            {width: 15.0},      //추가금액
            {width: 15.0},      //지불요금
            {width: 15.0},      //합계금액
            {width: 12.0},      //결제타입
            {width: 15.0},      //결제시간

        ]
    }
    fromMap(no,v) {
        let s = {
            alignment: {horizontal: "center"},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }

        return [
            {v: no, t: "n", s: s},
            {v: v.carNum, t: "s", s: s},
            {v: v.driverId, t: "s", s: s},
            {
                v: `${dateFormatFuncForExcel(v.stDtti, 'YYYY-MM-DD HH:mm:ss')} `,
                t: "s",
                s: s
            },
            {
                v: `${dateFormatFuncForExcel(v.payStartDtti, 'YYYY-MM-DD HH:mm:ss')} `,
                t: "s",
                s: s
            },
            {v: meterToKilo(v.tripDist), t: "n", z: '0.0', s: s},

            {v: v.distFare, t: "n", z: "#,##0", s: s},
            {v: v.voucherDiscount, t: "n", z: "#,##0", s: s},
            {v: v.hipassFee, t: "n", z: "#,##0", s: s},
            {v: v.callFee, t: "n", z: "#,##0", s: s},
            {v: v.addFare, t: "n", z: "#,##0", s: s},
            {v: ((parseInt(v.distFare) - parseInt(v.voucherDiscount)) + (parseInt(v.hipassFee) + parseInt(v.callFee) + parseInt(v.addFare))) , t: "n", z: "#,##0", s: s},
            {v: v.payTotal, t: "n", z: "#,##0", s: s},
            {v: convertPayTypeToTxt(v.payType), t: "s", s: s},
            {
                v: `${dateFormatFuncForExcel(v.edDtti, 'HH:mm')} `,
                t: "s",
                s: s
            },

        ]

    }

    fields() {
        let s = {
            fill: {fgColor: {rgb: "FFFF00"}},
            alignment: {horizontal: "center"},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }
        return [
            {key: "no", label: {v: "순번", t: "s", s: s}},
            {key: "carNum", label:  {v: "차량번호", t: "s", s: s}},
            {key: "driverId", label:  {v: "사원번호", t: "s", s: s}},
            {key: "stDtti", label:  {v: "운행시작", t: "s", s: s}},
            {key: "payStartDtti", label: {v: "운행종료", t: "s", s: s}},
            {key: "tripDist", label: {v: "운행거리", t: "s", s: s}},
            {key: "distFare", label:{v: "승차요금", t: "s", s: s}},
            {key: "voucherDiscount", label:{v: "할인요금", t: "s", s: s}},
            {key: "hipassFee", label: {v: "통행요금", t: "s", s: s}},
            {key: "callFee", label: {v: "호출요금", t: "s", s: s}},
            {key: "addFare", label:{v: "추가금액", t: "s", s: s}},
            {key: "jibulFee", label: {v: "지불요금", t: "s", s: s}},
            {key: "payTotal", label: {v: "합계금액", t: "s", s: s}},
            {key: "payType", label:{v: "결제타입", t: "s", s: s}},
            {key: "edDtti", label: {v: "결제시간", t: "s", s: s}}
        ]
    }
}
class excelPrivateTachoVoucherDto {
    constructor(carNum, stDtti, edDtti , payStartDtti, distFare, addFare, hipassFee, voucherDiscount, payTotal, tripDist ,payType, callFee) {

        this.carNum = carNum;
        this.stDtti = stDtti;
        this.edDtti = edDtti;
        this.payStartDtti = payStartDtti;
        this.distFare = distFare;
        this.addFare = addFare;
        this.callFee = callFee;
        this.hipassFee = hipassFee;
        this.voucherDiscount = voucherDiscount;
        this.payTotal = payTotal;
        this.tripDist = tripDist;
        this.payType = payType;
        this.jibulFee = 0;
    }
    cols() {
        return [
            {width: 10.0},      //순번
            {width: 15.0},      //차량번호
            {width: 25.0},      //운행시작
            {width: 25.0},      //운행종료
            {width: 12.0},      //운행거리
            {width: 15.0},      //승차요금
            {width: 15.0},      //할인요금
            {width: 15.0},      //통행요금
            {width: 15.0},      //호출요금
            {width: 15.0},      //추가금액
            {width: 15.0},      //지불요금
            {width: 15.0},      //합계금액
            {width: 12.0},      //결제타입
            {width: 15.0},      //결제시간

        ]
    }
    fromMap(no,v) {
        let s = {
            alignment: {horizontal: "center"},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }

        return [
            {v: no, t: "n", s: s},
            {v: v.carNum, t: "s", s: s},
            {
                v: `${dateFormatFuncForExcel(v.stDtti, 'YYYY-MM-DD HH:mm:ss')} `,
                t: "s",
                s: s
            },
            {
                v: `${dateFormatFuncForExcel(v.payStartDtti, 'YYYY-MM-DD HH:mm:ss')} `,
                t: "s",
                s: s
            },
            {v: meterToKilo(v.tripDist), t: "n", z: '0.0', s: s},

            {v: v.distFare, t: "n", z: "#,##0", s: s},
            {v: v.voucherDiscount, t: "n", z: "#,##0", s: s},
            {v: v.hipassFee, t: "n", z: "#,##0", s: s},
            {v: v.callFee, t: "n", z: "#,##0", s: s},
            {v: v.addFare, t: "n", z: "#,##0", s: s},
            {v: ((parseInt(v.distFare) - parseInt(v.voucherDiscount)) + (parseInt(v.hipassFee) + parseInt(v.callFee) + parseInt(v.addFare))) , t: "n", z: "#,##0", s: s},
            {v: v.payTotal, t: "n", z: "#,##0", s: s},
            {v: convertPayTypeToTxt(v.payType), t: "s", s: s},
            {
                v: `${dateFormatFuncForExcel(v.edDtti, 'HH:mm')} `,
                t: "s",
                s: s
            },

        ]

    }

    fields() {
        let s = {
            fill: {fgColor: {rgb: "FFFF00"}},
            alignment: {horizontal: "center"},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }
        return [
            {key: "no", label: {v: "순번", t: "s", s: s}},
            {key: "carNum", label:  {v: "차량번호", t: "s", s: s}},
            {key: "stDtti", label:  {v: "운행시작", t: "s", s: s}},
            {key: "payStartDtti", label: {v: "운행종료", t: "s", s: s}},
            {key: "tripDist", label: {v: "운행거리", t: "s", s: s}},
            {key: "distFare", label:{v: "승차요금", t: "s", s: s}},
            {key: "voucherDiscount", label:{v: "할인요금", t: "s", s: s}},
            {key: "hipassFee", label: {v: "통행요금", t: "s", s: s}},
            {key: "callFee", label: {v: "호출요금", t: "s", s: s}},
            {key: "addFare", label:{v: "추가금액", t: "s", s: s}},
            {key: "jibulFee", label: {v: "지불요금", t: "s", s: s}},
            {key: "payTotal", label: {v: "합계금액", t: "s", s: s}},
            {key: "payType", label:{v: "결제타입", t: "s", s: s}},
            {key: "edDtti", label: {v: "결제시간", t: "s", s: s}}
        ]
    }
}

class baseCloseExcelSumEntity {
    constructor() {
        this.noCnt = 0;
        this.carNumberCnt = new Set([]);
        this.employeeNumberCnt = new Set([]);
        this.startDate = "";
        this.endDate = "";
        this.payFare = 0;
        this.hipassFare = 0;
        this.addFare = 0;
        this.allFare = 0;
        this.workDist = 0;
        this.blankDist = 0;
        this.workTime = 0;
        this.allTime = 0;
        this.allDist = 0;
        this.blankTime = 0;
        this.callFare = 0;
    }

    add(v) {
        this.noCnt += 1;
        this.carNumberCnt.add(v.carNum);
        this.employeeNumberCnt.add(v.driverId);
        this.startDate = (v.stDtti < this.startDate || this.startDate === "") ? v.stDtti : this.startDate;
        this.endDate = (v.edDtti > this.endDate || this.startDate === "") ? v.edDtti : this.endDate;
        this.payFare += parseInt(v.payFare);
        this.hipassFare += parseInt(v.hipassFare);
        this.callFare += parseInt(v.callFare);
        this.addFare += parseInt(v.addFare);
        this.allFare += parseInt(v.allFare);
        this.workDist += v.workDist;
        this.blankDist += v.blankDist;
        this.allDist += v.allDist;
        this.workTime += v.workTime;
        this.allTime += v.allTime;
        this.blankTime += v.blankTime;
        return this;
    }

    res() {
        let s = {
            fill: {fgColor: {rgb: "33CCCC"}},
            alignment: {horizontal: "center"},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }
        return [
            {v: `총 ${this.noCnt}건`, t: "s", s: s},
            {v: `${this.carNumberCnt.size}대`, t: "s", s: s},
            {v: `${this.employeeNumberCnt.size}명`, t: "s", s: s},
            {
                v: `${dateFormatFuncForExcel(this.startDate, 'YYYY-MM-DD HH:mm:ss')} ~ ${dateFormatFuncForExcel(this.endDate, 'YYYY-MM-DD HH:mm:ss')}`,
                t: "s",
                s: s
            },
            {v: this.payFare, t: "n", z: "#,##0", s: s},
            {v: this.hipassFare, t: "n", z: "#,##0", s: s},
            {v: this.callFare, t: "n", z: "#,##0", s: s},
            {v: this.addFare, t: "n", z: "#,##0", s: s},
            {v: this.allFare, t: "n", z: "#,##0", s: s},
            {v: meterToKilo(this.workDist), t: "n", z: "0.0", s: s},
            {v: meterToKilo(this.blankDist), t: "n", z: "0.0", s: s},
            {v: meterToKilo(this.allDist), t: "n", z: "0.0", s: s},
            {v: secToDayPercent(this.workTime), t: "n", z: "[h]:mm:ss", s: s},
            {v: secToDayPercent(this.blankTime), t: "n", z: "[h]:mm:ss", s: s},
            {v: secToDayPercent(this.allTime), t: "n", z: "[h]:mm:ss", s: s}
        ]
    }
}

// 지불
class jibulCloseExcelEntity {
    constructor(no, carNum, driverId, stDtti, edDtti, hipassFare, addFare, blankDist, blankTime, callFare, allDist, allFare, payFare, allTime, workDist, workTime,cardFare,cashFare) {
        this.no = no;
        this.carNum = carNum;
        this.driverId = driverId;
        this.stDtti = stDtti;
        this.edDtti = edDtti;
        this.hipassFare = hipassFare;
        // this.addFare = addFare + callFare;
        this.addFare = addFare;
        this.blankDist = blankDist;
        this.blankTime = blankTime;
        this.callFare = callFare;
        this.allDist = allDist;
        this.allFare = allFare;
        this.payFare = payFare;
        this.allTime = allTime;
        this.workDist = workDist;
        this.workTime = workTime;
        this.cardFare = cardFare;
        this.cashFare = cashFare;
    }

    fromMap(no, v) {
        let s = {
            alignment: {horizontal: "center"},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }
        return [
            {v: no, t: "n", s: s},
            {v: v.carNum, t: "s", s: s},
            {v: v.driverId, t: "s", z: '@', s: s},
            {
                v: `${dateFormatFuncForExcel(v.stDtti, 'YYYY-MM-DD HH:mm:ss')} ~ ${dateFormatFuncForExcel(v.edDtti, 'YYYY-MM-DD HH:mm:ss')}`,
                t: "s",
                s: s
            },
            {v: v.payFare, t: "n", z: "#,##0", s: s},
            {v: v.hipassFare, t: "n", z: "#,##0", s: s},
            {v: v.callFare, t: "n", z: "#,##0", s: s},
            {v: parseInt(v.addFare), t: "n", z: "#,##0", s: s},
            {v: v.allFare, t: "n", z: "#,##0", s: s},
            {v: v.cashFare, t: "n", z: "#,##0", s: s},
            {v: v.cardFare, t: "n", z: "#,##0", s: s},
            {v: meterToKilo(v.workDist), t: "n", z: "0.0", s: s},
            {v: meterToKilo(v.blankDist), t: "n", z: "0.0", s: s},
            {v: meterToKilo(v.allDist), t: "n", z: "0.0", s: s},
            {v: secToDayPercent(v.workTime), t: "n", z: "[h]:mm:ss", s: s},
            {v: secToDayPercent(v.blankTime), t: "n", z: "[h]:mm:ss", s: s},
            {v: secToDayPercent(v.allTime), t: "n", z: "[h]:mm:ss", s: s}
        ]
    }

    fields() {
        let s = {
            fill: {fgColor: {rgb: "FFFF00"}},
            alignment: {horizontal: "center"},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }
        return [
            {key: "no", label: {v: "순번", t: "s", s: s}},
            {key: "carNum", label: {v: "차량번호", t: "s", s: s}},
            {key: "driverId", label: {v: "사원번호", t: "s", s: s}},
            {key: "period", label: {v: "운행기간", t: "s", s: s}},
            {key: "payFare", label: {v: "현금카드 합계 (원)", t: "s", s: s}},
            {key: "hipassFare", label: {v: "통행요금 (원)", t: "s", s: s}},
            {key: "callFare", label: {v: "호출요금 (원)", t: "s", s: s}},
            {key: "addFare", label: {v: "추가금액 (원)", t: "s", s: s}},
            {key: "allFare", label: {v: "합계금액 (원)", t: "s", s: s}},
            {key: "cashFare", label: {v: "현금금액 (원)", t: "s", s: s}},
            {key: "cardFare", label: {v: "카드금액 (원)", t: "s", s: s}},
            {key: "workDist", label: {v: "영업거리(KM)", t: "s", s: s}},
            {key: "blankDist", label: {v: "주행거리(KM)", t: "s", s: s}},
            {key: "allDist", label: {v: "총 운행거리(KM)", t: "s", s: s}},
            {key: "workTime", label: {v: "영업시간", t: "s", s: s}},
            {key: "blankTime", label: {v: "주행시간", t: "s", s: s}},
            {key: "allTime", label: {v: "근무시간", t: "s", s: s}},
        ]
    }

    cols() {
        return [
            {width: 10.0},
            {width: 15.0},
            {width: 12.0},
            {width: 35.0},
            {width: 17.0},
            {width: 17.0},
            {width: 20.0},
            {width: 17.0},
            {width: 17.0},
            {width: 17.0},
            {width: 17.0},
            {width: 17.0},
            {width: 17.0},
            {width: 17.0},
            {width: 10.0},
            {width: 10.0},
            {width: 10.0},
        ]
    }
}

class jibulCloseExcelSumEntity {
    constructor() {
        this.noCnt = 0;
        this.carNumberCnt = new Set([]);
        this.employeeNumberCnt = new Set([]);
        this.startDate = "";
        this.endDate = "";
        this.hipassFare = 0;
        this.addFare = 0;
        this.blankDist = 0;
        this.blankTime = 0;
        this.callFare = 0;
        this.allDist = 0;
        this.allFare = 0;
        this.payFare = 0;
        this.allTime = 0;
        this.workDist = 0;
        this.workTime = 0;
        this.cashFare = 0;
        this.cardFare = 0;
    }

    add(v) {
        this.noCnt += 1;
        this.carNumberCnt.add(v.carNum);
        this.employeeNumberCnt.add(v.driverId);
        this.startDate = (v.stDtti < this.startDate || this.startDate === "") ? v.stDtti : this.startDate;
        this.endDate = (v.edDtti > this.endDate || this.startDate === "") ? v.edDtti : this.endDate;
        this.hipassFare += parseInt(v.hipassFare);
        this.addFare += (parseInt(v.addFare));
        this.blankDist += v.blankDist;
        this.blankTime += v.blankTime;
        this.callFare += (parseInt(v.callFare));
        this.allDist += v.allDist;
        this.allFare += parseInt(v.allFare);
        this.payFare += parseInt(v.payFare);
        this.allTime += v.allTime;
        this.workDist += v.workDist;
        this.workTime += v.workTime;
        this.cardFare += parseInt(v.cardFare);
        this.cashFare += parseInt(v.cashFare);
        return this;
    }

    res() {
        let s = {
            fill: {fgColor: {rgb: "33CCCC"}},
            alignment: {horizontal: "center"},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }
        return [
            {v: `총 ${this.noCnt}건`, t: "s", s: s},
            {v: `${this.carNumberCnt.size}대`, t: "s", s: s},
            {v: `${this.employeeNumberCnt.size}명`, t: "s", s: s},
            {
                v: `${dateFormatFuncForExcel(this.startDate, 'YYYY-MM-DD HH:mm:ss')} ~ ${dateFormatFuncForExcel(this.endDate, 'YYYY-MM-DD HH:mm:ss')}`,
                t: "s",
                s: s
            },
            {v: this.payFare, t: "n", z: "#,##0", s: s},
            {v: this.hipassFare, t: "n", z: "#,##0", s: s},
            {v: this.callFare, t: "n", z: "#,##0", s: s},
            {v: this.addFare, t: "n", z: "#,##0", s: s},
            {v: this.allFare, t: "n", z: "#,##0", s: s},
            {v: this.cashFare, t: "n", z: "#,##0", s: s},
            {v: this.cardFare, t: "n", z: "#,##0", s: s},
            {v: meterToKilo(this.workDist), t: "n", z: "0.0", s: s},
            {v: meterToKilo(this.blankDist), t: "n", z: "0.0", s: s},
            {v: meterToKilo(this.allDist), t: "n", z: "0.0", s: s},
            {v: secToDayPercent(this.workTime), t: "n", z: "[h]:mm:ss", s: s},
            {v: secToDayPercent(this.blankTime), t: "n", z: "[h]:mm:ss", s: s},
            {v: secToDayPercent(this.allTime), t: "n", z: "[h]:mm:ss", s: s}
        ]
    }
}

// 세계
class segyeCloseExcelEntity {
    constructor(no, carNum, driverId, driverName, stDtti, edDtti, allFare, workDist, blankDist, workTime, allTime, allDist, blankTime, cardFare, cashFare) {
        this.no = no;
        this.carNum = carNum;
        this.driverId = driverId;
        this.driverName = driverName;
        this.stDtti = stDtti;
        this.edDtti = edDtti;
        this.allFare = allFare;
        this.workDist = workDist;
        this.blankDist = blankDist;
        this.workTime = workTime;
        this.allTime = allTime;
        this.allDist = allDist;
        this.blankTime = blankTime;
        this.cardFare = cardFare;
        this.cashFare = cashFare;
    }

    cols() {
        return [
            {width: 10.0},
            {width: 15.0},
            {width: 12.0},
            {width: 12.0},
            {width: 35.0},
            {width: 15.0},
            {width: 15.0},
            {width: 15.0},
            {width: 17.0},
            {width: 17.0},
            {width: 17.0},
            {width: 10.0},
            {width: 10.0},
            {width: 10.0},
            {width: 10.0},

        ]
    }

    fromMap(no, v) {
        let s = {
            alignment: {horizontal: "center"},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }
        return [
            {v: no, t: "n", s: s},
            {v: v.carNum, t: "s", s: s},
            {v: v.driverId, t: "s", z: '@', s: s},
            {v: v.driverName, t: "s", s: s},
            {
                v: `${dateFormatFuncForExcel(v.stDtti, 'YYYY-MM-DD HH:mm')} ~ ${dateFormatFuncForExcel(v.edDtti, 'YYYY-MM-DD HH:mm')}`,
                t: "s",
                s: s
            },
            {v: parseInt(v.allFare) - parseInt(v.addFare) - parseInt(v.hipassFare), t: "n", z: "#,##0", s: s},
            {v: (v.cashFare) , t: "n", z: "#,##0", s: s},
            {v: (v.cardFare) , t: "n", z: "#,##0", s: s},
            {v: meterToKilo(v.workDist), t: "n", z: "0.0", s: s},
            {v: meterToKilo(v.blankDist), t: "n", z: "0.0", s: s},
            {v: meterToKilo(v.allDist), t: "n", z: "0.0", s: s},
            {v: secToDayPercent(v.workTime), t: "n", z: "[h]:mm", s: s},
            {v: secToDayPercent(v.blankTime), t: "n", z: "[h]:mm", s: s},
            {v: secToDayPercent(v.allTime), t: "n", z: "[h]:mm", s: s}
        ]
    }

    fields() {
        let s = {
            fill: {fgColor: {rgb: "FFFF00"}},
            alignment: {horizontal: "center"},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }
        return [
            {key: "no", label: {v: "순번", t: "s", s: s}},
            {key: "carNum", label: {v: "차량번호", t: "s", s: s}},
            {key: "driverId", label: {v: "사원번호", t: "s", s: s}},
            {key: "driverName", label: {v: "기사명", t: "s", s: s}},
            {key: "period", label: {v: "운행시작~운행종료", t: "s", s: s}},
            {key: "allFare", label: {v: "미터수입금(원)", t: "s", s: s}},
            {key: "cashFare", label: {v: "현금금액(원)", t: "s", s: s}},
            {key: "cardFare", label: {v: "카드금액(원)", t: "s", s: s}},
            {key: "workDist", label: {v: "영업거리(KM)", t: "s", s: s}},
            {key: "emptyDist", label: {v: "주행거리(KM)", t: "s", s: s}},
            {key: "allDist", label: {v: "총 운행거리(KM)", t: "s", s: s}},
            {key: "workTime", label: {v: "영업시간", t: "s", s: s}},
            {key: "blankTime", label: {v: "주행시간", t: "s", s: s}},
            {key: "allTime", label: {v: "근무시간", t: "s", s: s}},
        ]
    }
}

class segyeCloseExcelSumEntity {
    constructor() {
        this.noCnt = 0;
        this.carNumberCnt = new Set([]);
        this.employeeNumberCnt = new Set([]);
        this.startDate = "";
        this.endDate = "";
        this.segyeFare = 0;
        this.cardFare = 0;
        this.cashFare = 0;
        this.workDist = 0;
        this.blankDist = 0;
        this.workTime = 0;
        this.allTime = 0;
        this.allDist = 0;
        this.blankTime = 0;
    }

    add(v) {
        this.noCnt += 1;
        this.carNumberCnt.add(v.carNum);
        this.employeeNumberCnt.add(v.driverId);
        this.startDate = (v.stDtti < this.startDate || this.startDate === "") ? v.stDtti : this.startDate;
        this.endDate = (v.edDtti > this.endDate || this.startDate === "") ? v.edDtti : this.endDate;
        this.segyeFare += parseInt(v.allFare) - parseInt(v.addFare) - parseInt(v.hipassFare);
        this.workDist += v.workDist;
        this.blankDist += v.blankDist;
        this.workTime += v.workTime;
        this.allTime += v.allTime;
        this.allDist += v.allDist;
        this.blankTime += v.blankTime;
        this.cashFare += parseInt(v.cashFare);
        this.cardFare += parseInt(v.cardFare);
        return this;
    }

    res() {
        let s = {
            fill: {fgColor: {rgb: "33CCCC"}},
            alignment: {horizontal: "center"},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }
        return [
            {v: `총 ${this.noCnt}건`, t: "s", s: s},
            {v: `${this.carNumberCnt.size}대`, t: "s", s: s},
            {v: `${this.employeeNumberCnt.size}명`, t: "s", s: s},
            {v: "", t: "s", s: s},
            {
                v: `${dateFormatFuncForExcel(this.startDate, 'YYYY-MM-DD HH:mm')} ~ ${dateFormatFuncForExcel(this.endDate, 'YYYY-MM-DD HH:mm')}`,
                t: "s",
                s: s
            },
            {v: this.segyeFare, t: "n", z: "#,##0", s: s},
            {v: this.cashFare, t: "n", z: "#,##0", s: s},
            {v: this.cardFare, t: "n", z: "#,##0", s: s},
            {v: meterToKilo(this.workDist), t: "n", z: "0.0", s: s},
            {v: meterToKilo(this.blankDist), t: "n", z: "0.0", s: s},
            {v: meterToKilo(this.allDist), t: "n", z: "0.0", s: s},
            {v: secToDayPercent(this.workTime), t: "n", z: "[h]:mm", s: s},
            {v: secToDayPercent(this.blankTime), t: "n", z: "[h]:mm", s: s},
            {v: secToDayPercent(this.allTime), t: "n", z: "[h]:mm", s: s}
        ]
    }
}

//근태관리
class commuteManageExcelEntity {
    constructor(carNum, driverId, stDtti, edDtti) {
        this.carNum = carNum;
        this.driverId = driverId;
        this.stDtti = stDtti;
        this.edDtti = edDtti;
    }

    fromMap(no, v) {
        let s = {
            alignment: {horizontal: "center"},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }
        return [
            {v: no, t: "n", s: s},
            {v: v.carNum, t: "s", s: s},
            {v: v.driverId, t: "s", z: '@', s: s},
            {
                v: v.stDtti != null ? `${dateFormatFuncForExcel(v.stDtti, 'YYYY-MM-DD HH:mm:ss')}` : '',
                t: "s",
                s: s
            },
            {
                v: v.edDtti != null ? `${dateFormatFuncForExcel(v.edDtti, 'YYYY-MM-DD HH:mm:ss')}` : '',
                t: "s",
                s: s
            }
        ]
    }

    fields() {
        let s = {
            fill: {fgColor: {rgb: "FFFF00"}},
            alignment: {horizontal: "center"},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }
        return [
            {key: "no", label: {v: "순번", t: "s", s: s}},
            {key: "carNum", label: {v: "차량번호", t: "s", s: s}},
            {key: "driverId", label: {v: "사원번호", t: "s", s: s}},
            {key: "stDtti", label: {v: "출근일자", t: "s", s: s}},
            {key: "edDtti", label: {v: "퇴근일자", t: "s", s: s}},
        ]
    }

    cols() {
        return [
            {width: 10.0},
            {width: 15.0},
            {width: 12.0},
            {width: 25.0},
            {width: 25.0}
        ]
    }
}

class commuteManageExcelSumEntity {
    constructor() {
        this.noCnt = 0;
        this.carNumberCnt = new Set([]);
        this.employeeNumberCnt = new Set([]);
        this.startDate = "";
        this.endDate = "";
    }

    add(v) {
        this.noCnt += 1;
        this.carNumberCnt.add(v.carNum);
        this.employeeNumberCnt.add(v.driverId);
        this.startDate = (v.stDtti < this.startDate || this.startDate === "") ? v.stDtti : this.startDate;
        this.endDate = (v.edDtti > this.endDate || this.startDate === "") ? v.edDtti : this.endDate;
        return this;
    }

    res() {
        let s = {
            fill: {fgColor: {rgb: "33CCCC"}},
            alignment: {horizontal: "center"},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }
        return [
            {v: `총 ${this.noCnt}건`, t: "s", s: s},
            {v: `${this.carNumberCnt.size}대`, t: "s", s: s},
            {v: `${this.employeeNumberCnt.size}명`, t: "s", s: s},
            {
                v: this.startDate ? `${dateFormatFuncForExcel(this.startDate, 'YYYY-MM-DD HH:mm:ss')}` : '-',
                t: "s",
                s: s
            },
            {
                v: this.endDate ? `${dateFormatFuncForExcel(this.endDate, 'YYYY-MM-DD HH:mm:ss')}` : '-',
                t: "s",
                s: s
            }
        ]
    }
}

class buttonEventExcelEntity {
    constructor(infoDtti, officeId, carNum, driverId, driveKey, driveSubkey, buttonVal, payType, fare, callFare, addFare, carX, carY, dist, apiDtti, viewYn, carType, cityName, hipassFare, voucherFare,driverLicense,duration) {
        this.infoDtti = infoDtti,
        this.officeId = officeId,
        this.carNum = carNum,
        this.driverId = driverId,
        this.driveKey = driveKey,
        this.driveSubkey = driveSubkey,
        this.buttonVal = buttonVal,
        this.payType = payType,
        this.fare = fare,
        this.callFare = callFare,
        this.addFare = addFare,
        this.dist = dist,
        this.carX = carX,
        this.carY = carY,
        this.viewYn = viewYn,
        this.apiDtti = apiDtti,
        this.carType = carType,
        this.cityName = cityName,
        this.hipassFare = hipassFare,
        this.voucherFare = voucherFare,
        this.driverLicense = driverLicense,
        this.duration = duration
    }

    fromMap(no, v) {
        let s = {
            alignment: {horizontal: "center"},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }
        return [
            {v: no, t: "n", s: s},
            {v: `${dateFormatFuncForExcel(v.infoDtti, 'YYYY-MM-DD HH:mm:ss')}`, t: "s", s: s},
            {v: v.officeId, t: "s", s: s},
            {v: v.carNum, t: "s", s: s},
            {v: v.driverId, t: "s", z: '@', s: s},
            {v: v.driveKey, t: "s", s: s},
            {v: v.driveSubkey, t: "s", s: s},
            {v: `${MeterStatusType[v.buttonVal]}(${v.buttonVal})`, t: "s", s: s},
            {v: `${convertPayTypeToTxt(v.payType)}`, t: "s", s: s},
            {v: v.fare, t: "n", z: "#,##0", s: s},
            {v: v.callFare, t: "n", z: "#,##0", s: s},
            {v: v.addFare, t: "n", z: "#,##0", s: s},
            {v: v.hipassFare, t: "n", z: "#,##0", s: s},
            {v: v.voucherFare, t: "n", z: "#,##0", s: s},
            {v: v.carX.toString(), t: "s", s: s},
            {v: v.carY.toString(), t: "s", s: s},
            {v: meterToKilo(v.dist), t: "n", z: "#,##0.0", s: s},
            {v: `${dateFormatFuncForExcel(v.apiDtti, 'YYYY-MM-DD HH:mm:ss')}`, t: "s", s: s},
            {v: v.carType, t: "s", s: s},
            {v: v.cityName, t: "s", s: s},
            {v: v.driverLicense, t: "s", s: s},
            {v: v.duration, t: "s", s: s},
        ]
    }

    fields() {
        let s = {
            fill: {fgColor: {rgb: "FFFF00"}},
            alignment: {horizontal: "center"},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }
        return [
            {key: "no", label: {v: "순번", t: "s", s: s}},
            {key: "infoDtti", label: {v: "데이터 생성일시", t: "s", s: s}},
            {key: "officeId", label: {v: "사업자번호", t: "s", s: s}},
            {key: "carNum", label: {v: "차량번호", t: "s", s: s}},
            {key: "driverId", label: {v: "기사 아이디", t: "s", s: s}},
            {key: "driveKey", label: {v: "순번", t: "s", s: s}},
            {key: "driveSubkey", label: {v: "타코용 서브키", t: "s", s: s}},
            {key: "buttonVal", label: {v: "미터기 상태", t: "s", s: s}},
            {key: "payType", label: {v: "결제타입", t: "s", s: s}},
            {key: "fare", label: {v: "요금", t: "s", s: s}},
            {key: "callFare", label: {v: "호출 요금", t: "s", s: s}},
            {key: "addFare", label: {v: "추가 요금", t: "s", s: s}},
            {key: "hipassFare", label: {v: "통행 요금", t: "s", s: s}},
            {key: "voucherFare", label: {v: "바우처 요금", t: "s", s: s}},
            {key: "carX", label: {v: "차량 위도", t: "s", s: s}},
            {key: "carY", label: {v: "차량 경도", t: "s", s: s}},
            {key: "dist", label: {v: "이동 거리", t: "s", s: s}},
            {key: "apiDtti", label: {v: "저장 일시", t: "s", s: s}},
            {key: "carType", label: {v: "영업 타입", t: "s", s: s}},
            {key: "cityName", label: {v: "영업 지역", t: "s", s: s}},
            {key: "driverLicense", label: {v: "기사 자격번호", t: "s", s: s}},
            {key: "duration", label: {v: "공차시간", t: "s", s: s}},
        ]
    }

    cols() {
        return [
            {width: 10.0},
            {width: 35.0},
            {width: 15.0},
            {width: 15.0},
            {width: 15.0},
            {width: 15.0},
            {width: 15.0},
            {width: 15.0},
            {width: 15.0},
            {width: 15.0},
            {width: 15.0},
            {width: 15.0},
            {width: 15.0},
            {width: 15.0},
            {width: 15.0},
            {width: 15.0},
            {width: 15.0},
            {width: 35.0},
            {width: 15.0},
            {width: 15.0},
            {width: 15.0},
            {width: 15.0}
        ]
    }
}

// 기본
class baseClosingDayExcelEntity {
    constructor(carNum, driverId, minDtti, maxDtti, workTime, allTime, workDist, blankDist, fare, payFare, hipassFare, addFare
        , cashFare, cardFare, callFare, payType, payDtti, viewYn, allDist, blankTime) {
        this.carNum = carNum;
        this.driverId = driverId;
        this.minDtti = minDtti;
        this.maxDtti = maxDtti;
        this.workTime = workTime;
        this.allTime = allTime;
        this.workDist = workDist;
        this.blankDist = blankDist;
        this.fare = fare;
        this.payFare = payFare;
        this.hipassFare = hipassFare;
        this.addFare = addFare;
        this.callFare = callFare;
        this.payType = payType;
        this.payDtti = payDtti;
        this.viewYn = viewYn;
        //this.totalDist = workDist + blankDist;
        this.allDist = allDist;
        this.blankTime = blankTime;
        this.cashFare = cashFare;
        this.cardFare = cardFare;
    }

    fromMap(no, v) {
        let s = {
            alignment: {horizontal: "center"},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }
        return [
            {v: no, t: "n", s: s},
            {v: v.carNum, t: "s", s: s},
            {v: v.driverId, t: "s", z: '@', s: s},
            {
                v: `${dateFormatFuncForExcel(v.minDtti, 'YYYY-MM-DD HH:mm:ss')} ~ ${dateFormatFuncForExcel(v.maxDtti, 'YYYY-MM-DD HH:mm:ss')}`,
                t: "s",
                s: s
            },
            {v: v.payFare, t: "n", z: "#,##0", s: s},
            {v: v.cashFare, t: "n", z: "#,##0", s: s},
            {v: v.cardFare, t: "n", z: "#,##0", s: s},
            {v: v.hipassFare, t: "n", z: "#,##0", s: s},
            {v: v.callFare, t: "n", z: "#,##0", s: s},
            {v: v.addFare, t: "n", z: "#,##0", s: s},
            {v: v.fare, t: "n", z: "#,##0", s: s},
            {v: meterToKilo(v.workDist), t: "n", z: '0.0', s: s},
            {v: meterToKilo(v.blankDist), t: "n", z: '0.0', s: s},
            {v: meterToKilo(v.allDist), t: "n", z: '0.0', s: s},
            {v: secToDayPercent(v.workTime), t: "n", z: "[h]:mm:ss", s: s},
            {v: secToDayPercent(v.blankTime), t: "n", z: "[h]:mm:ss", s: s},
            {v: secToDayPercent(v.allTime), t: "n", z: "[h]:mm:ss", s: s}
        ]
    }

    fields() {
        let s = {
            fill: {fgColor: {rgb: "FFFF00"}},
            alignment: {horizontal: "center"},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }
        return [
            {key: "no", label: {v: "순번", t: "s", s: s}},
            {key: "carNum", label: {v: "차량번호", t: "s", s: s}},
            {key: "driverId", label: {v: "사원번호", t: "s", s: s}},
            {key: "period", label: {v: "운행기간", t: "s", s: s}},
            {key: "payFare", label: {v: "미터금액 (원)", t: "s", s: s}},
            {key: "cashFare", label: {v: "현금 (원)", t: "s", s: s}},
            {key: "cardFare", label: {v: "카드금액 (원)", t: "s", s: s}},
            {key: "hipassFare", label: {v: "통행요금 (원)", t: "s", s: s}},
            {key: "callFare", label: {v: "호출요금 (원)", t: "s", s: s}},
            {key: "addFare", label: {v: "추가금액 (원)", t: "s", s: s}},
            {key: "fare", label: {v: "합계금액 (원)", t: "s", s: s}},
            {key: "workDist", label: {v: "영업거리(KM)", t: "s", s: s}},
            {key: "blankDist", label: {v: "주행거리(KM)", t: "s", s: s}},
            {key: "allDist", label: {v: "총 운행거리(KM)", t: "s", s: s}},
            {key: "workTime", label: {v: "영업시간", t: "s", s: s}},
            {key: "blankTime", label: {v: "주행시간", t: "s", s: s}},
            {key: "allTime", label: {v: "근무시간", t: "s", s: s}},
        ]
    }

    cols() {
        return [
            {width: 10.0},
            {width: 15.0},
            {width: 12.0},
            {width: 35.0},
            {width: 15.0},
            {width: 15.0},
            {width: 15.0},
            {width: 15.0},
            {width: 15.0},
            {width: 15.0},
            {width: 15.0},
            {width: 15.0},
            {width: 15.0},
            {width: 17.0},
            {width: 10.0},
            {width: 10.0},
            {width: 10.0},
        ]
    }
}

class baseClosingDayExcelSumEntity {
    constructor() {
        this.noCnt = 0;
        this.carNumberCnt = new Set([]);
        this.employeeNumberCnt = new Set([]);
        this.startDate = "";
        this.endDate = "";
        this.payFare = 0;
        this.hipassFare = 0;
        this.addFare = 0;
        this.fare = 0;
        this.workDist = 0;
        this.blankDist = 0;
        this.workTime = 0;
        this.allTime = 0;
        this.callFare = 0;
        this.cashFare = 0;
        this.cardFare = 0;
    }

    add(v) {
        this.noCnt += 1;
        this.carNumberCnt.add(v.carNum);
        this.employeeNumberCnt.add(v.driverId);
        this.startDate = (v.minDtti < this.startDate || this.startDate === "") ? v.minDtti : this.startDate;
        this.endDate = (v.maxDtti > this.endDate || this.startDate === "") ? v.maxDtti : this.endDate;
        this.payFare += v.payFare;
        this.hipassFare += v.hipassFare;
        this.callFare += v.callFare;
        this.addFare += v.addFare;
        this.fare += v.fare;
        this.workDist += v.workDist;
        this.blankDist += v.blankDist;
        this.workTime += v.workTime;
        this.allTime += v.allTime;
        this.cashFare += v.cashFare;
        this.cardFare += v.cardFare;
        return this;
    }

    res() {
        let s = {
            fill: {fgColor: {rgb: "33CCCC"}},
            alignment: {horizontal: "center"},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }
        return [
            {v: `총 ${this.noCnt}건`, t: "s", s: s},
            {v: `${this.carNumberCnt.size}대`, t: "s", s: s},
            {v: `${this.employeeNumberCnt.size}명`, t: "s", s: s},
            {
                v: `${dateFormatFuncForExcel(this.startDate, 'YYYY-MM-DD HH:mm:ss')} ~ ${dateFormatFuncForExcel(this.endDate, 'YYYY-MM-DD HH:mm:ss')}`,
                t: "s",
                s: s
            },
            {v: this.payFare, t: "n", z: "#,##0", s: s},
            {v: this.cashFare, t: "n", z: "#,##0", s: s},
            {v: this.cardFare, t: "n", z: "#,##0", s: s},
            {v: this.hipassFare, t: "n", z: "#,##0", s: s},
            {v: this.callFare, t: "n", z: "#,##0", s: s},
            {v: this.addFare, t: "n", z: "#,##0", s: s},
            {v: this.fare, t: "n", z: "#,##0", s: s},
            {v: meterToKilo(this.workDist), t: "n", z: '0.0', s: s},
            {v: meterToKilo(this.blankDist), t: "n", z: '0.0', s: s},
            {v: meterToKilo(this.workDist + this.blankDist), t: "n", z: '0.0', s: s},
            {v: secToDayPercent(this.workTime), t: "n", z: "[h]:mm:ss", s: s},
            {v: secToDayPercent(this.allTime - this.workTime), t: "n", z: "[h]:mm:ss", s: s},
            {v: secToDayPercent(this.allTime), t: "n", z: "[h]:mm:ss", s: s}
        ]
    }
}

class baseDrivingDistExcelEntity {
    constructor(carNum, driverId, dist, time, workDist, blankDist) {
        this.carNum = carNum;
        this.driverId = driverId;
        this.dist = dist;
        this.time = time;
        this.workDist = workDist;
        this.blankDist = blankDist;
    }

    fromMap(no, v) {
        let s = {
            alignment: {horizontal: "center"},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }
        return [
            {v: no, t: "n", s: s},
            {v: v.carNum, t: "s", s: s},
            {v: v.driverId, t: "s", z: '@', s: s},
            {v: meterToKilo(v.dist), t: "n", z: "#,##0.0", s: s},
            {v: secToDayPercent(v.time), t: "n", z: "[h]:mm:ss", s: s},
            {v: meterToKilo(v.workDist), t: "n", z: '0.0', s: s},
            {v: meterToKilo(v.blankDist), t: "n", z: '0.0', s: s},
        ]
    }

    fields() {
        let s = {
            fill: {fgColor: {rgb: "FFFF00"}},
            alignment: {horizontal: "center"},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }
        return [
            {key: "no", label: {v: "순번", t: "s", s: s}},
            {key: "carNum", label: {v: "차량번호", t: "s", s: s}},
            {key: "driverId", label: {v: "사원번호", t: "s", s: s}},
            {key: "dist", label: {v: "총 운행거리(KM)", t: "s", s: s}},
            {key: "time", label: {v: "근무시간", t: "s", s: s}},
            {key: "workDist", label: {v: "영업거리(KM)", t: "s", s: s}},
            {key: "blankDist", label: {v: "주행거리(KM)", t: "s", s: s}},
        ]
    }

    cols() {
        return [
            {width: 10.0},
            {width: 15.0},
            {width: 12.0},
            {width: 15.0},
            {width: 17.0},
            {width: 15.0},
            {width: 15.0},
        ]
    }
}

class baseDrivingDistExcelSumEntity {
    constructor() {
        this.noCnt = 0;
        this.carNumberCnt = new Set([]);
        this.employeeNumberCnt = new Set([]);
        this.dist = 0;
        this.time = 0;
        this.workDist = 0;
        this.blankDist = 0;
    }

    add(v) {
        this.noCnt += 1;
        this.carNumberCnt.add(v.carNum);
        this.employeeNumberCnt.add(v.driverId);
        this.dist += v.dist;
        this.time += v.time;
        this.workDist += v.workDist;
        this.blankDist += v.blankDist;
        return this;
    }

    res() {
        let s = {
            fill: {fgColor: {rgb: "33CCCC"}},
            alignment: {horizontal: "center"},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }
        return [
            {v: `총 ${this.noCnt}건`, t: "s", s: s},
            {v: `${this.carNumberCnt.size}대`, t: "s", s: s},
            {v: `${this.employeeNumberCnt.size}명`, t: "s", s: s},
            {v: meterToKilo(this.dist), t: "n", z: "#,##0.0", s: s},
            {v: secToDayPercent(this.time), t: "n", z: "[h]:mm:ss", s: s},
            {v: meterToKilo(this.workDist), t: "n", z: '0.0', s: s},
            {v: meterToKilo(this.blankDist), t: "n", z: '0.0', s: s},
        ]
    }
}

// 지불
class jibulClosingDayExcelEntity {
    constructor(no, carNum, driverId, minDtti, maxDtti, period, hipassFare, addFare, blankDist, blankTime, callFare, cardFare, cashFare, allDist, fare, payFare, allTime, workDist, workTime) {
        this.no = no;
        this.carNum = carNum;
        this.driverId = driverId;
        this.minDtti = minDtti;
        this.maxDtti = maxDtti;
        this.period = period;
        this.hipassFare = hipassFare;
        this.addFare = addFare;
        this.blankDist = blankDist;
        this.blankTime = blankTime;
        this.callFare = callFare;
        this.cardFare = cardFare;
        this.cashFare = cashFare;
        this.allDist = allDist;
        this.fare = fare;
        this.payFare = payFare;
        this.allTime = allTime;
        this.workDist = workDist;
        this.workTime = workTime;
    }

    fromMap(no, v) {
        let s = {
            alignment: {horizontal: "center"},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }
        return [
            {v: no, t: "n", s: s},
            {v: v.carNum, t: "s", s: s},
            {v: v.driverId, t: "s", z: '@', s: s},
            {
                v: `${dateFormatFuncForExcel(v.minDtti, 'YYYY-MM-DD HH:mm:ss')} ~ ${dateFormatFuncForExcel(v.maxDtti, 'YYYY-MM-DD HH:mm:ss')}`,
                t: "s",
                s: s
            },
            {v: v.cashFare, t: "n", z: "#,##0", s: s},
            {v: v.cardFare, t: "n", z: "#,##0", s: s},
            {v: v.payFare, t: "n", z: "#,##0", s: s},
            {v: v.hipassFare, t: "n", z: "#,##0", s: s},
            {v: v.callFare, t: "n", z: "#,##0", s: s},
            {v: v.addFare, t: "n", z: "#,##0", s: s},
            {v: v.fare, t: "n", z: "#,##0", s: s},
            {v: meterToKilo(v.workDist), t: "n", z: '0.0', s: s},
            {v: meterToKilo(v.blankDist), t: "n", z: '0.0', s: s},
            {v: meterToKilo(v.workDist + v.blankDist), t: "n", z: '0.0', s: s},
            {v: secToDayPercent(v.workTime), t: "n", z: "[h]:mm:ss", s: s},
            {v: secToDayPercent(v.allTime - v.workTime), t: "n", z: "[h]:mm:ss", s: s},
            {v: secToDayPercent(v.allTime), t: "n", z: "[h]:mm:ss", s: s}
        ]
    }

    fields() {
        let s = {
            fill: {fgColor: {rgb: "FFFF00"}},
            alignment: {horizontal: "center"},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }
        return [
            {key: "no", label: {v: "순번", t: "s", s: s}},
            {key: "carNum", label: {v: "차량번호", t: "s", s: s}},
            {key: "driverId", label: {v: "사원번호", t: "s", s: s}},
            {key: "period", label: {v: "운행기간", t: "s", s: s}},
            {key: "cashFare", label: {v: "현금 금액 (원)", t: "s", s: s}},
            {key: "cardFare", label: {v: "카드 금액 (원)", t: "s", s: s}},
            {key: "payFare", label: {v: "현금카드 합계 (원)", t: "s", s: s}},
            {key: "hipassFare", label: {v: "통행요금 (원)", t: "s", s: s}},
            {key: "callFare", label: {v: "호출요금 (원)", t: "s", s: s}},
            {key: "addFare", label: {v: "추가금액 (원)", t: "s", s: s}},
            {key: "fare", label: {v: "합계금액 (원)", t: "s", s: s}},
            {key: "workDist", label: {v: "영업거리(KM)", t: "s", s: s}},
            {key: "allEmptyDist", label: {v: "주행거리(KM)", t: "s", s: s}},
            {key: "blankDist", label: {v: "총 운행거리(KM)", t: "s", s: s}},
            {key: "workTime", label: {v: "영업시간", t: "s", s: s}},
            {key: "blankTime", label: {v: "주행시간", t: "s", s: s}},
            {key: "allTime", label: {v: "근무시간", t: "s", s: s}},
        ]
    }

    cols() {
        return [
            {width: 10.0},
            {width: 15.0},
            {width: 12.0},
            {width: 35.0},
            {width: 17.0},
            {width: 17.0},
            {width: 20.0},
            {width: 17.0},
            {width: 17.0},
            {width: 17.0},
            {width: 17.0},
            {width: 17.0},
            {width: 17.0},
            {width: 17.0},
            {width: 10.0},
            {width: 10.0},
            {width: 10.0},
        ]
    }
}

class jibulClosingDayExcelSumEntity {
    constructor() {
        this.noCnt = 0;
        this.carNumberCnt = new Set([]);
        this.employeeNumberCnt = new Set([]);
        this.startDate = "";
        this.endDate = "";
        this.hipassFare = 0;
        this.addFare = 0;
        this.blankDist = 0;
        this.blankTime = 0;
        this.callFare = 0;
        this.cardFare = 0;
        this.cashFare = 0;
        this.allDist = 0;
        this.fare = 0;
        this.payFare = 0;
        this.allTime = 0;
        this.workDist = 0;
        this.workTime = 0;
    }

    add(v) {
        this.noCnt += 1;
        this.carNumberCnt.add(v.carNum);
        this.employeeNumberCnt.add(v.driverId);
        this.startDate = (v.minDtti < this.startDate || this.startDate === "") ? v.minDtti : this.startDate;
        this.endDate = (v.maxDtti > this.endDate || this.startDate === "") ? v.maxDtti : this.endDate;
        this.hipassFare += v.hipassFare;
        this.addFare += v.addFare;
        this.blankDist += v.blankDist;
        this.blankTime += v.blankTime;
        this.callFare += v.callFare;
        this.cardFare += v.cardFare;
        this.cashFare += v.cashFare;
        this.allDist += v.allDist;
        this.fare += v.fare;
        this.payFare += v.payFare;
        this.allTime += v.allTime;
        this.workDist += v.workDist;
        this.workTime += v.workTime;
        return this;
    }

    res() {
        let s = {
            fill: {fgColor: {rgb: "33CCCC"}},
            alignment: {horizontal: "center"},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }
        return [
            {v: `총 ${this.noCnt}건`, t: "s", s: s},
            {v: `${this.carNumberCnt.size}대`, t: "s", s: s},
            {v: `${this.employeeNumberCnt.size}명`, t: "s", s: s},
            {
                v: `${dateFormatFuncForExcel(this.startDate, 'YYYY-MM-DD HH:mm:ss')} ~ ${dateFormatFuncForExcel(this.endDate, 'YYYY-MM-DD HH:mm:ss')}`,
                t: "s",
                s: s
            },
            {v: this.cashFare, t: "n", z: "#,##0", s: s},
            {v: this.cardFare, t: "n", z: "#,##0", s: s},
            {v: this.payFare, t: "n", z: "#,##0", s: s},
            {v: this.hipassFare, t: "n", z: "#,##0", s: s},
            {v: this.callFare, t: "n", z: "#,##0", s: s},
            {v: this.addFare, t: "n", z: "#,##0", s: s},
            {v: this.fare, t: "n", z: "#,##0", s: s},
            {v: meterToKilo(this.workDist), t: "n", z: '0.0', s: s},
            {v: meterToKilo(this.blankDist), t: "n", z: '0.0', s: s},
            {v: meterToKilo(this.workDist + this.blankDist), t: "n", z: '0.0', s: s},
            {v: secToDayPercent(this.workTime), t: "n", z: "[h]:mm:ss", s: s},
            {v: secToDayPercent(this.allTime - this.workTime), t: "n", z: "[h]:mm:ss", s: s},
            {v: secToDayPercent(this.allTime), t: "n", z: "[h]:mm:ss", s: s}
        ]
    }
}

// 세계
class segyeClosingDayExcelEntity {
    constructor(no, carNum, driverId, driverName, period, fare, workDist, blankDist, workTime, allTime, allDist, blankTime, cashFare, cardFare) {
        this.no = no;
        this.carNum = carNum;
        this.driverId = driverId;
        this.driverName = driverName;
        this.period = period
        this.fare = fare;
        this.workDist = workDist;
        this.blankDist = blankDist;
        this.workTime = workTime;
        this.allTime = allTime;
        this.allDist = allDist;
        this.blankTime = blankTime;
        this.cashFare = cashFare;
        this.cardFare = cardFare;
    }

    cols() {
        return [
            {width: 10.0},
            {width: 15.0},
            {width: 12.0},
            {width: 12.0},
            {width: 35.0},
            {width: 15.0},
            {width: 15.0},
            {width: 15.0},
            {width: 15.0},
            {width: 15.0},
            {width: 17.0},
            {width: 10.0},
            {width: 10.0},
            {width: 10.0},
        ]
    }

    fromMap(no, v) {
        let s = {
            alignment: {horizontal: "center"},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }
        return [
            {v: no, t: "n", s: s},
            {v: v.carNum, t: "s", s: s},
            {v: v.driverId, t: "s", z: '@', s: s},
            {v: v.driverName, t: "s", s: s},
            {
                v: `${dateFormatFuncForExcel(v.minDtti, 'YYYY-MM-DD HH:mm')} ~ ${dateFormatFuncForExcel(v.maxDtti, 'YYYY-MM-DD HH:mm')}`,
                t: "s",
                s: s
            },
            {v: (v.fare - v.addFare - v.hipassFare), t: "n", z: "#,##0", s: s},
            {v: v.cashFare, t: "n", z: "#,##0", s: s},
            {v: v.cardFare, t: "n", z: "#,##0", s: s},
            {v: meterToKilo(v.workDist), t: "n", z: '0.0', s: s},
            {v: meterToKilo(v.blankDist), t: "n", z: '0.0', s: s},
            //{v: meterToKilo(v.workDist + v.blankDist), t: "n", z: '0.0 ,s: s},
            {v: meterToKilo(v.allDist), t: "n", z: '0.0', s: s},
            {v: secToDayPercent(v.workTime), t: "n", z: "[h]:mm", s: s},
            //{v: secToDayPercent(v.allTime - v.workTime), t: "n", z: "[h]:mm:ss", s: s},
            {v: secToDayPercent(v.blankTime), t: "n", z: "[h]:mm", s: s},
            {v: secToDayPercent(v.allTime), t: "n", z: "[h]:mm", s: s}
        ]
    }

    fields() {
        let s = {
            fill: {fgColor: {rgb: "FFFF00"}},
            alignment: {horizontal: "center"},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }
        return [
            {key: "no", label: {v: "순번", t: "s", s: s}},
            {key: "carNum", label: {v: "차량번호", t: "s", s: s}},
            {key: "driverId", label: {v: "사원번호", t: "s", s: s}},
            {key: "driverName", label: {v: "기사명", t: "s", s: s}},
            {key: "period", label: {v: "운행시작~운행종료", t: "s", s: s}},
            {key: "fare", label: {v: "미터수입금(원)", t: "s", s: s}},
            {key: "cashFare", label: {v: "현금(원)", t: "s", s: s}},
            {key: "cardFare", label: {v: "카드금액(원)", t: "s", s: s}},
            {key: "workDist", label: {v: "영업거리(KM)", t: "s", s: s}},
            {key: "emptyDist", label: {v: "주행거리(KM)", t: "s", s: s}},
            //{key: "totalDist", label: {v: "총 운행거리(KM)", t: "s", s: s}},
            {key: "allDist", label: {v: "총 운행거리(KM)", t: "s", s: s}},
            {key: "workTime", label: {v: "영업시간", t: "s", s: s}},
            {key: "blankTime", label: {v: "주행시간", t: "s", s: s}},
            {key: "allTime", label: {v: "근무시간", t: "s", s: s}},
        ]
    }
}

class segyeClosingDayExcelSumEntity {
    constructor() {
        this.noCnt = 0;
        this.carNumberCnt = new Set([]);
        this.employeeNumberCnt = new Set([]);
        this.startDate = "";
        this.endDate = "";
        this.segyeFare = 0;
        this.workDist = 0;
        this.blankDist = 0;
        this.workTime = 0;
        this.allTime = 0;
        this.cashFare = 0;
        this.cardFare = 0;
    }

    add(v) {
        this.noCnt += 1;
        this.carNumberCnt.add(v.carNum);
        this.employeeNumberCnt.add(v.driverId);
        this.startDate = (v.minDtti < this.startDate || this.startDate === "") ? v.minDtti : this.startDate;
        this.endDate = (v.maxDtti > this.endDate || this.startDate === "") ? v.maxDtti : this.endDate;
        this.segyeFare += (v.fare - v.addFare - v.hipassFare);
        this.workDist += v.workDist;
        this.blankDist += v.blankDist;
        this.workTime += v.workTime;
        this.allTime += v.allTime;
        this.cashFare += v.cashFare;
        this.cardFare += v.cardFare;
        return this;
    }

    res() {
        let s = {
            fill: {fgColor: {rgb: "33CCCC"}},
            alignment: {horizontal: "center"},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }
        return [
            {v: `총 ${this.noCnt}건`, t: "s", s: s},
            {v: `${this.carNumberCnt.size}대`, t: "s", s: s},
            {v: `${this.employeeNumberCnt.size}명`, t: "s", s: s},
            {v: "", t: "s", s: s},
            {
                v: `${dateFormatFuncForExcel(this.startDate, 'YYYY-MM-DD HH:mm')} ~ ${dateFormatFuncForExcel(this.endDate, 'YYYY-MM-DD HH:mm')}`,
                t: "s",
                s: s
            },
            {v: this.segyeFare, t: "n", z: "#,##0", s: s},
            {v: this.cashFare, t: "n", z: "#,##0", s: s},
            {v: this.cardFare, t: "n", z: "#,##0", s: s},
            {v: meterToKilo(this.workDist), t: "n", z: '0.0', s: s},
            {v: meterToKilo(this.blankDist), t: "n", z: '0.0', s: s},
            {v: meterToKilo(this.workDist + this.blankDist), t: "n", z: '0.0', s: s},
            {v: secToDayPercent(this.workTime), t: "n", z: "[h]:mm", s: s},
            {v: secToDayPercent(this.allTime - this.workTime), t: "n", z: "[h]:mm", s: s},
            {v: secToDayPercent(this.allTime), t: "n", z: "[h]:mm", s: s}
        ]
    }
}


// 기본
class baseCloseDayCommuteExcelEntity {
    fromMap(no, v) {
        let s = {
            alignment: {horizontal: "center"},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }
        return [
            {v: no, t: "n", s: s},
            {v: v.carNum, t: "s", s: s},
            {v: v.driverId, t: "s", z: '@', s: s},
            {
                v: `${dateFormatFuncForExcel(v.stDtti, 'YYYY-MM-DD HH:mm:ss')} ~ ${dateFormatFuncForExcel(v.edDtti, 'YYYY-MM-DD HH:mm:ss')}`,
                t: "s",
                s: s
            },
            {v: v.payFare, t: "n", z: "#,##0", s: s},
            {v: v.cashFare, t: "n", z: "#,##0", s: s},
            {v: v.cardFare, t: "n", z: "#,##0", s: s},
            {v: v.hipassFare, t: "n", z: "#,##0", s: s},
            {v: v.callFare, t: "n", z: "#,##0", s: s},
            {v: parseInt(v.addFare), t: "n", z: "#,##0", s: s},
            {v: v.allFare, t: "n", z: "#,##0", s: s},
            {v: meterToKilo(v.workDist), t: "n", z: "0.0", s: s},
            {v: meterToKilo(v.blankDist), t: "n", z: "0.0", s: s},
            {v: meterToKilo(v.allDist), t: "n", z: "0.0", s: s},
            {v: secToDayPercent(v.workTime), t: "n", z: "[h]:mm:ss", s: s},
            {v: secToDayPercent(v.blankTime), t: "n", z: "[h]:mm:ss", s: s},
            {v: secToDayPercent(v.allTime), t: "n", z: "[h]:mm:ss", s: s}
        ]
    }

    fields() {
        let s = {
            fill: {fgColor: {rgb: "FFFF00"}},
            alignment: {horizontal: "center"},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }
        return [
            {key: "no", label: {v: "순번", t: "s", s: s}},
            {key: "carNum", label: {v: "차량번호", t: "s", s: s}},
            {key: "driverId", label: {v: "사원번호", t: "s", s: s}},
            {key: "period", label: {v: "운행기간", t: "s", s: s}},
            {key: "payFare", label: {v: "미터금액 (원)", t: "s", s: s}},
            {key: "cashFare", label: {v: "현금 (원)", t: "s", s: s}},
            {key: "cardFare", label: {v: "카드금액 (원)", t: "s", s: s}},
            {key: "hipassFare", label: {v: "통행요금 (원)", t: "s", s: s}},
            {key: "callFare", label: {v: "호출요금 (원)", t: "s", s: s}},
            {key: "addFare", label: {v: "추가금액 (원)", t: "s", s: s}},
            {key: "allFare", label: {v: "합계금액 (원)", t: "s", s: s}},
            {key: "workDist", label: {v: "영업거리(KM)", t: "s", s: s}},
            {key: "blankDist", label: {v: "주행거리(KM)", t: "s", s: s}},
            {key: "allDist", label: {v: "총 운행거리(KM)", t: "s", s: s}},
            {key: "workTime", label: {v: "영업시간", t: "s", s: s}},
            {key: "blankTime", label: {v: "주행시간", t: "s", s: s}},
            {key: "allTime", label: {v: "근무시간", t: "s", s: s}},
        ]
    }

    cols() {
        return [
            {width: 10.0},
            {width: 15.0},
            {width: 12.0},
            {width: 35.0},
            {width: 15.0},
            {width: 15.0},
            {width: 15.0},
            {width: 15.0},
            {width: 15.0},
            {width: 15.0},
            {width: 15.0},
            {width: 15.0},
            {width: 15.0},
            {width: 17.0},
            {width: 10.0},
            {width: 10.0},
            {width: 10.0},
        ]
    }
}

class baseCloseDayCommuteExcelSumEntity {
    constructor() {
        this.noCnt = 0;
        this.carNumberCnt = new Set([]);
        this.employeeNumberCnt = new Set([]);
        this.startDate = "";
        this.endDate = "";
        this.payFare = 0;
        this.hipassFare = 0;
        this.addFare = 0;
        this.allFare = 0;
        this.workDist = 0;
        this.blankDist = 0;
        this.workTime = 0;
        this.allTime = 0;
        this.allDist = 0;
        this.blankTime = 0;
        this.callFare = 0;
        this.cashFare = 0;
        this.cardFare = 0;
    }

    add(v) {
        this.noCnt += 1;
        this.carNumberCnt.add(v.carNum);
        this.employeeNumberCnt.add(v.driverId);
        this.startDate = (v.stDtti < this.startDate || this.startDate === "") ? v.stDtti : this.startDate;
        this.endDate = (v.edDtti > this.endDate || this.startDate === "") ? v.edDtti : this.endDate;
        this.payFare += parseInt(v.payFare);
        this.hipassFare += parseInt(v.hipassFare);
        this.callFare += parseInt(v.callFare);
        this.addFare += parseInt(v.addFare);
        this.allFare += parseInt(v.allFare);
        this.workDist += v.workDist;
        this.blankDist += v.blankDist;
        this.allDist += v.allDist;
        this.workTime += v.workTime;
        this.allTime += v.allTime;
        this.blankTime += v.blankTime;
        this.cashFare += parseInt(v.cashFare);
        this.cardFare += parseInt(v.cardFare);
        return this;
    }

    res() {
        let s = {
            fill: {fgColor: {rgb: "33CCCC"}},
            alignment: {horizontal: "center"},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }
        return [
            {v: `총 ${this.noCnt}건`, t: "s", s: s},
            {v: `${this.carNumberCnt.size}대`, t: "s", s: s},
            {v: `${this.employeeNumberCnt.size}명`, t: "s", s: s},
            {
                v: `${dateFormatFuncForExcel(this.startDate, 'YYYY-MM-DD HH:mm:ss')} ~ ${dateFormatFuncForExcel(this.endDate, 'YYYY-MM-DD HH:mm:ss')}`,
                t: "s",
                s: s
            },
            {v: this.payFare, t: "n", z: "#,##0", s: s},
            {v: this.cashFare, t: "n", z: "#,##0", s: s},
            {v: this.cardFare, t: "n", z: "#,##0", s: s},
            {v: this.hipassFare, t: "n", z: "#,##0", s: s},
            {v: this.callFare, t: "n", z: "#,##0", s: s},
            {v: this.addFare, t: "n", z: "#,##0", s: s},
            {v: this.allFare, t: "n", z: "#,##0", s: s},
            {v: meterToKilo(this.workDist), t: "n", z: "0.0", s: s},
            {v: meterToKilo(this.blankDist), t: "n", z: "0.0", s: s},
            {v: meterToKilo(this.allDist), t: "n", z: "0.0", s: s},
            {v: secToDayPercent(this.workTime), t: "n", z: "[h]:mm:ss", s: s},
            {v: secToDayPercent(this.blankTime), t: "n", z: "[h]:mm:ss", s: s},
            {v: secToDayPercent(this.allTime), t: "n", z: "[h]:mm:ss", s: s}
        ]
    }
}

// 지불
class jibulCloseDayCommuteExcelEntity {
    fromMap(no, v) {
        let s = {
            alignment: {horizontal: "center"},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }
        return [
            {v: no, t: "n", s: s},
            {v: v.carNum, t: "s", s: s},
            {v: v.driverId, t: "s", z: '@', s: s},
            {
                v: `${dateFormatFuncForExcel(v.stDtti, 'YYYY-MM-DD HH:mm:ss')} ~ ${dateFormatFuncForExcel(v.edDtti, 'YYYY-MM-DD HH:mm:ss')}`,
                t: "s",
                s: s
            },
            {v: v.cashFare, t: "n", z: "#,##0", s: s},
            {v: v.cardFare, t: "n", z: "#,##0", s: s},
            {v: parseInt(v.allFare) - (parseInt(v.hipassFare) + parseInt(v.callFare) + parseInt(v.addFare)), t: "n", z: "#,##0", s: s},
            {v: v.hipassFare, t: "n", z: "#,##0", s: s},
            {v: v.callFare, t: "n", z: "#,##0", s: s},
            {v: parseInt(v.addFare), t: "n", z: "#,##0", s: s},
            {v: v.allFare, t: "n", z: "#,##0", s: s},
            {v: meterToKilo(v.workDist), t: "n", z: "0.0", s: s},
            {v: meterToKilo(v.blankDist), t: "n", z: "0.0", s: s},
            {v: meterToKilo(v.allDist), t: "n", z: "0.0", s: s},
            {v: secToDayPercent(v.workTime), t: "n", z: "[h]:mm:ss", s: s},
            {v: secToDayPercent(v.blankTime), t: "n", z: "[h]:mm:ss", s: s},
            {v: secToDayPercent(v.allTime), t: "n", z: "[h]:mm:ss", s: s}
        ]
    }

    fields() {
        let s = {
            fill: {fgColor: {rgb: "FFFF00"}},
            alignment: {horizontal: "center"},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }
        return [
            {key: "no", label: {v: "순번", t: "s", s: s}},
            {key: "carNum", label: {v: "차량번호", t: "s", s: s}},
            {key: "driverId", label: {v: "사원번호", t: "s", s: s}},
            {key: "period", label: {v: "운행기간", t: "s", s: s}},
            {key: "cashFare", label: {v: "현금 금액 (원)", t: "s", s: s}},
            {key: "cardFare", label: {v: "카드 금액 (원)", t: "s", s: s}},
            {key: "payFare", label: {v: "현금카드 합계 (원)", t: "s", s: s}},
            {key: "hipassFare", label: {v: "통행요금 (원)", t: "s", s: s}},
            {key: "callFare", label: {v: "호출요금 (원)", t: "s", s: s}},
            {key: "addFare", label: {v: "추가금액 (원)", t: "s", s: s}},
            {key: "allFare", label: {v: "합계금액 (원)", t: "s", s: s}},
            {key: "workDist", label: {v: "영업거리(KM)", t: "s", s: s}},
            {key: "blankDist", label: {v: "주행거리(KM)", t: "s", s: s}},
            {key: "allDist", label: {v: "총 운행거리(KM)", t: "s", s: s}},
            {key: "workTime", label: {v: "영업시간", t: "s", s: s}},
            {key: "blankTime", label: {v: "주행시간", t: "s", s: s}},
            {key: "allTime", label: {v: "근무시간", t: "s", s: s}},
        ]
    }

    cols() {
        return [
            {width: 10.0},
            {width: 15.0},
            {width: 12.0},
            {width: 35.0},
            {width: 17.0},
            {width: 17.0},
            {width: 20.0},
            {width: 17.0},
            {width: 17.0},
            {width: 17.0},
            {width: 17.0},
            {width: 17.0},
            {width: 17.0},
            {width: 10.0},
            {width: 10.0},
            {width: 10.0},
        ]
    }
}

class jibulCloseDayCommuteExcelSumEntity {
    constructor() {
        this.noCnt = 0;
        this.carNumberCnt = new Set([]);
        this.employeeNumberCnt = new Set([]);
        this.startDate = "";
        this.endDate = "";
        this.hipassFare = 0;
        this.addFare = 0;
        this.blankDist = 0;
        this.blankTime = 0;
        this.callFare = 0;
        this.cardFare = 0;
        this.cashFare = 0;
        this.allDist = 0;
        this.allFare = 0;
        this.payFare = 0;
        this.allTime = 0;
        this.workDist = 0;
        this.workTime = 0;
    }

    add(v) {
        this.noCnt += 1;
        this.carNumberCnt.add(v.carNum);
        this.employeeNumberCnt.add(v.driverId);
        this.startDate = (v.stDtti < this.startDate || this.startDate === "") ? v.stDtti : this.startDate;
        this.endDate = (v.edDtti > this.endDate || this.startDate === "") ? v.edDtti : this.endDate;
        this.hipassFare += parseInt(v.hipassFare);
        this.addFare += (parseInt(v.addFare));
        this.blankDist += v.blankDist;
        this.blankTime += v.blankTime;
        this.callFare += (parseInt(v.callFare));
        this.cardFare += parseInt(v.cardFare);
        this.cashFare += parseInt(v.cashFare);
        this.allDist += v.allDist;
        this.allFare += parseInt(v.allFare);
        this.payFare += parseInt(v.payFare);
        this.allTime += v.allTime;
        this.workDist += v.workDist;
        this.workTime += v.workTime;
        return this;
    }

    res() {
        let s = {
            fill: {fgColor: {rgb: "33CCCC"}},
            alignment: {horizontal: "center"},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }
        return [
            {v: `총 ${this.noCnt}건`, t: "s", s: s},
            {v: `${this.carNumberCnt.size}대`, t: "s", s: s},
            {v: `${this.employeeNumberCnt.size}명`, t: "s", s: s},
            {
                v: `${dateFormatFuncForExcel(this.startDate, 'YYYY-MM-DD HH:mm:ss')} ~ ${dateFormatFuncForExcel(this.endDate, 'YYYY-MM-DD HH:mm:ss')}`,
                t: "s",
                s: s
            },
            {v: this.cashFare, t: "n", z: "#,##0", s: s},
            {v: this.cardFare, t: "n", z: "#,##0", s: s},
            {v: this.payFare, t: "n", z: "#,##0", s: s},
            {v: this.hipassFare, t: "n", z: "#,##0", s: s},
            {v: this.callFare, t: "n", z: "#,##0", s: s},
            {v: this.addFare, t: "n", z: "#,##0", s: s},
            {v: this.allFare, t: "n", z: "#,##0", s: s},
            {v: meterToKilo(this.workDist), t: "n", z: "0.0", s: s},
            {v: meterToKilo(this.blankDist), t: "n", z: "0.0", s: s},
            {v: meterToKilo(this.allDist), t: "n", z: "0.0", s: s},
            {v: secToDayPercent(this.workTime), t: "n", z: "[h]:mm:ss", s: s},
            {v: secToDayPercent(this.blankTime), t: "n", z: "[h]:mm:ss", s: s},
            {v: secToDayPercent(this.allTime), t: "n", z: "[h]:mm:ss", s: s}
        ]
    }
}

// 세계
class segyeCloseDayCommuteExcelEntity {
    constructor(no, carNum, driverId, driverName, stDtti, edDtti, allFare, workDist, blankDist, workTime, allTime, allDist, blankTime, cashFare, cardFare) {
        this.no = no;
        this.carNum = carNum;
        this.driverId = driverId;
        this.driverName = driverName;
        this.stDtti = stDtti;
        this.edDtti = edDtti;
        this.allFare = allFare;
        this.workDist = workDist;
        this.blankDist = blankDist;
        this.workTime = workTime;
        this.allTime = allTime;
        this.allDist = allDist;
        this.blankTime = blankTime;
        this.cashFare = cashFare;
        this.cardFare = cardFare;
    }

    cols() {
        return [
            {width: 10.0},
            {width: 15.0},
            {width: 12.0},
            {width: 12.0},
            {width: 35.0},
            {width: 15.0},
            {width: 15.0},
            {width: 15.0},
            {width: 15.0},
            {width: 15.0},
            {width: 17.0},
            {width: 10.0},
            {width: 10.0},
            {width: 10.0},
        ]
    }

    fromMap(no, v) {
        let s = {
            alignment: {horizontal: "center"},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }
        return [
            {v: no, t: "n", s: s},
            {v: v.carNum, t: "s", s: s},
            {v: v.driverId, t: "s", z: '@', s: s},
            {v: v.driverName, t: "s", s: s},
            {
                v: `${dateFormatFuncForExcel(v.stDtti, 'YYYY-MM-DD HH:mm')} ~ ${dateFormatFuncForExcel(v.edDtti, 'YYYY-MM-DD HH:mm')}`,
                t: "s",
                s: s
            },
            {v: parseInt(v.allFare) - parseInt(v.addFare) - parseInt(v.hipassFare), t: "n", z: "#,##0", s: s},
            {v: v.cashFare, t: "n", z: "#,##0", s: s},
            {v: v.cardFare, t: "n", z: "#,##0", s: s},
            {v: meterToKilo(v.workDist), t: "n", z: "0.0", s: s},
            {v: meterToKilo(v.blankDist), t: "n", z: "0.0", s: s},
            {v: meterToKilo(v.allDist), t: "n", z: "0.0", s: s},
            {v: secToDayPercent(v.workTime), t: "n", z: "[h]:mm", s: s},
            {v: secToDayPercent(v.blankTime), t: "n", z: "[h]:mm", s: s},
            {v: secToDayPercent(v.allTime), t: "n", z: "[h]:mm", s: s}
        ]
    }

    fields() {
        let s = {
            fill: {fgColor: {rgb: "FFFF00"}},
            alignment: {horizontal: "center"},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }
        return [
            {key: "no", label: {v: "순번", t: "s", s: s}},
            {key: "carNum", label: {v: "차량번호", t: "s", s: s}},
            {key: "driverId", label: {v: "사원번호", t: "s", s: s}},
            {key: "driverName", label: {v: "기사명", t: "s", s: s}},
            {key: "period", label: {v: "운행시작~운행종료", t: "s", s: s}},
            {key: "allFare", label: {v: "미터금액 (원)", t: "s", s: s}},
            {key: "cashFare", label: {v: "현금 (원)", t: "s", s: s}},
            {key: "cardFare", label: {v: "카드금액(원)", t: "s", s: s}},
            {key: "workDist", label: {v: "영업거리(KM)", t: "s", s: s}},
            {key: "emptyDist", label: {v: "주행거리(KM)", t: "s", s: s}},
            {key: "allDist", label: {v: "총 운행거리(KM)", t: "s", s: s}},
            {key: "workTime", label: {v: "영업시간", t: "s", s: s}},
            {key: "blankTime", label: {v: "주행시간", t: "s", s: s}},
            {key: "allTime", label: {v: "근무시간", t: "s", s: s}},
        ]
    }
}

class segyeCloseDayCommuteExcelSumEntity {
    constructor() {
        this.noCnt = 0;
        this.carNumberCnt = new Set([]);
        this.employeeNumberCnt = new Set([]);
        this.startDate = "";
        this.endDate = "";
        this.segyeFare = 0;
        this.workDist = 0;
        this.blankDist = 0;
        this.workTime = 0;
        this.allTime = 0;
        this.allDist = 0;
        this.blankTime = 0;
        this.cashFare = 0;
        this.cardFare = 0;
        this.payFare = 0;
    }

    add(v) {
        this.noCnt += 1;
        this.carNumberCnt.add(v.carNum);
        this.employeeNumberCnt.add(v.driverId);
        this.startDate = (v.stDtti < this.startDate || this.startDate === "") ? v.stDtti : this.startDate;
        this.endDate = (v.edDtti > this.endDate || this.startDate === "") ? v.edDtti : this.endDate;
        this.segyeFare += parseInt(v.allFare) - parseInt(v.addFare) - parseInt(v.hipassFare);
        this.workDist += v.workDist;
        this.blankDist += v.blankDist;
        this.workTime += v.workTime;
        this.allTime += v.allTime;
        this.allDist += v.allDist;
        this.blankTime += v.blankTime;
        this.cashFare += parseInt(v.cashFare);
        this.cardFare += parseInt(v.cardFare);
        this.payFare += parseInt(v.payFare);
        return this;
    }

    res() {
        let s = {
            fill: {fgColor: {rgb: "33CCCC"}},
            alignment: {horizontal: "center"},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }
        return [
            {v: `총 ${this.noCnt}건`, t: "s", s: s},
            {v: `${this.carNumberCnt.size}대`, t: "s", s: s},
            {v: `${this.employeeNumberCnt.size}명`, t: "s", s: s},
            {v: "", t: "s", s: s},
            {
                v: `${dateFormatFuncForExcel(this.startDate, 'YYYY-MM-DD HH:mm')} ~ ${dateFormatFuncForExcel(this.endDate, 'YYYY-MM-DD HH:mm')}`,
                t: "s",
                s: s
            },
            {v: this.segyeFare, t: "n", z: "#,##0", s: s},
            {v: this.cashFare, t: "n", z: "#,##0", s: s},
            {v: this.cardFare, t: "n", z: "#,##0", s: s},
            {v: meterToKilo(this.workDist), t: "n", z: "0.0", s: s},
            {v: meterToKilo(this.blankDist), t: "n", z: "0.0", s: s},
            {v: meterToKilo(this.allDist), t: "n", z: "0.0", s: s},
            {v: secToDayPercent(this.workTime), t: "n", z: "[h]:mm", s: s},
            {v: secToDayPercent(this.blankTime), t: "n", z: "[h]:mm", s: s},
            {v: secToDayPercent(this.allTime), t: "n", z: "[h]:mm", s: s}
        ]
    }
}

class DriverInfoExcelEntity {
    constructor(
        driverId,
        driverLicense,
        employeeName
    ) {
        this.driverId = driverId;
        this.driverLicense = driverLicense;
        this.employeeName = employeeName;
    }

    toExcelRow() {
        let s = {
            alignment: {horizontal: "center"},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }
        return [
            {v: this.driverId, t: "s", s: s},
            {v: this.employeeName, t: "s", s: s},
            {v: this.driverLicense, t: "s", s: s},
        ]
    }

    static excelCols() {
        return [
            {width: 20.0},
            {width: 25.0},
            {width: 25.0},
        ]
    }

    static excelTitles() {
        return DriverInfoExcelEntity.excelFields().map(v => v.label);
    }

    static excelFields() {
        let s = {
            fill: {fgColor: {rgb: "FFFF00"}},
            alignment: {horizontal: "center"},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }
        return [
            {key: "driverId", label: {v: "사원번호", t: "s", s: s}},
            {key: "employeeName", label: {v: "기사명", t: "s", s: s}},
            {key: "driverLicense", label: {v: "운전자격번호", t: "s", s: s}},
        ];
    }

    static fromApi(v) {
        return new DriverInfoExcelEntity(
            v.employeeNum,
            v.driverId,
            v.employeeName || '',
        );
    }
}

class DriverInfoWithCardExcelEntity {
    constructor(
        driverId,
        driverLicense,
        employeeName,
        employeeType
    ) {
        this.driverId = driverId;
        this.driverLicense = driverLicense;
        this.employeeName = employeeName;
        this.employeeType = employeeType || '-';
    }

    toExcelRow() {
        let s = {
            alignment: {horizontal: "center"},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }
        return [
            {v: this.driverId, t: "s", s: s},
            {v: this.employeeName, t: "s", s: s},
            {v: this.driverLicense, t: "s", s: s},
            {v: this.employeeType, t: "s", s: s},
        ]
    }

    static excelCols() {
        return [
            {width: 20.0},
            {width: 25.0},
            {width: 25.0},
            {width: 25.0},
        ]
    }

    static excelTitles() {
        return DriverInfoWithCardExcelEntity.excelFields().map(v => v.label);
    }

    static excelFields() {
        let s = {
            fill: {fgColor: {rgb: "FFFF00"}},
            alignment: {horizontal: "center"},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }
        return [
            {key: "driverId", label: {v: "사원번호", t: "s", s: s}},
            {key: "employeeName", label: {v: "기사명", t: "s", s: s}},
            {key: "driverLicense", label: {v: "운전자격번호", t: "s", s: s}},
            {key: "employeeType", label: {v: "권한", t: "s", s: s}},
        ];
    }

    static fromApi(v) {
        return new DriverInfoWithCardExcelEntity(
            v.employeeNum,
            v.driverId,
            v.employeeName || '',
            v.employeeType,
        );
    }
}

class VehicleInfoExcelEntity {
    constructor(
        officeId,
        carNum,
        driverId,
        carType,
    ) {
        this.officeId = officeId;
        this.carNum = carNum;
        this.driverId = driverId === 'AAAA' ? '기본' : driverId;
        this.carType = carTypeNames[carType];
    }

    toExcelRow() {
        let s = {
            alignment: {horizontal: "center"},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }
        return [
            {v: this.officeId, t: "s", s: s},
            {v: this.carNum, t: "s", s: s},
            {v: this.driverId, t: "s", s: s},
            {v: this.carType, t: "s", s: s},
        ]
    }

    static excelCols() {
        return [
            {width: 20.0},
            {width: 25.0},
            {width: 25.0},
            {width: 20.0},
        ]
    }

    static excelTitles() {
        return VehicleInfoExcelEntity.excelFields().map(v => v.label);
    }

    static excelFields() {
        let s = {
            fill: {fgColor: {rgb: "FFFF00"}},
            alignment: {horizontal: "center"},
            border: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}}
        }
        return [
            {key: "officeId", label: {v: "운수사아이디", t: "s", s: s}},
            {key: "carNum", label: {v: "차량번호", t: "s", s: s}},
            {key: "driverId", label: {v: "사원번호", t: "s", s: s}},
            {key: "carType", label: {v: "종류", t: "s", s: s}},
        ];
    }

    static fromApi(v) {
        return new VehicleInfoExcelEntity(
            v.officeId,
            v.carNum,
            v.driverId,
            v.carType,
        );
    }
}

const excelEntity = {
    excelType,
    baseExcelEntity,
    baseExcelSumEntity,
    basePeriodExcelEntity,
    basePeriodExcelSumEntity,
    segyeExcelEntity,
    segyeExcelSumEntity,
    segyePeriodExcelEntity,
    segyePeriodExcelSumEntity,
    aggregateDetailExcelEntity,
    jibulExcelEntity,
    jibulExcelSumEntity,
    jibulPeriodExcelEntity,
    jibulPeriodExcelSumEntity,
    drivingPerMinuteExcelEntity,
    drivingPrivatePerMinuteExcelEntity,
    baseCloseExcelEntity,
    baseCloseExcelSumEntity,
    excelTachoVoucherDto,
    excelPrivateTachoVoucherDto,
    jibulCloseExcelEntity,
    jibulCloseExcelSumEntity,
    segyeCloseExcelEntity,
    segyeCloseExcelSumEntity,
    commuteManageExcelEntity,
    commuteManageExcelSumEntity,
    buttonEventExcelEntity,
    baseClosingDayExcelEntity,
    baseClosingDayExcelSumEntity,
    baseDrivingDistExcelEntity,
    baseDrivingDistExcelSumEntity,
    segyeClosingDayExcelEntity,
    segyeClosingDayExcelSumEntity,
    jibulClosingDayExcelEntity,
    jibulClosingDayExcelSumEntity,
    baseCloseDayCommuteExcelEntity,
    baseCloseDayCommuteExcelSumEntity,
    jibulCloseDayCommuteExcelEntity,
    jibulCloseDayCommuteExcelSumEntity,
    segyeCloseDayCommuteExcelEntity,
    segyeCloseDayCommuteExcelSumEntity,
    DriverInfoExcelEntity,
    DriverInfoWithCardExcelEntity,
    VehicleInfoExcelEntity,
}

export default excelEntity
